import React,{Component}   from 'react';

//图片

import zhoubaotisong from './assets/img/zhoubaotisong.png';
import yuchililun from './assets/img/yuchililun.png';
import kehuxinxi61 from './assets/img/kehuxinxi61.png';
import kehuxinxi62 from './assets/img/kehuxinxi62.png';
import jingzhengduishou62 from './assets/img/jingzhengduishou62.jpg';

import bufene61 from './assets/img/bufene61.png';
import quanfene61 from './assets/img/quanfene61.png';
import muyou61 from './assets/img/muyou61.png';
import youwu61 from './assets/img/youwu61.png';
import youyou61 from './assets/img/youyou61.png';

import jieqiabiaozhun61 from './assets/img/jieqiabiaozhun61.png';
import jieqiabiaozhun62 from './assets/img/jieqiabiaozhun62.png';
import jieqiabiaozhun63 from './assets/img/jieqiabiaozhun63.png';
import toubiaoxize from './assets/img/toubiaoxize.png';
import xiaoshouguanli from './assets/img/xiaoshouguanli.png';
import caigouliucheng61 from './assets/img/caigouliucheng61.png';
import rukuliucheng61 from './assets/img/rukuliucheng61.png';
import chukuliucheng61 from './assets/img/chukuliucheng61.png';
import genzongbiao61 from './assets/img/genzongbiao61.png';
import pandianliucheng61 from './assets/img/pandianliucheng61.png';
import chejianshengchai61 from './assets/img/chejianshengchai61.png';

import dianshang11 from './assets/img/dianshang11.png';
import peijian11 from './assets/img/peijian11.png';
import kache11 from './assets/img/kache11.png';
import haiwai11 from './assets/img/haiwai11.png';
import keche11 from './assets/img/keche11.png';
import zhizao11 from './assets/img/zhizao11.png';
import yunhaochefu11 from './assets/img/yunhaochefu11.png';
import fuwujixiao from './assets/img/fuwujixiao.jpg';
import kaohebiaozhun from './assets/img/kaohebiaozhun.png';
import weixiushigukaohebiaozhun from './assets/img/weixiushigukaohebiaozhun.png';
import xiangshouchailvjifentiaojian from './assets/img/xiangshouchailvjifentiaojian.png';
import chailvbuzhujifen from './assets/img/chailvbuzhujifen.png';
import xiaoshoujiqiao from './assets/img/xiaoshoujiqiao.png';
import xiaoshouluojilian from './assets/img/xiaoshouluojilian.png';
import tuihuodan641 from './assets/img/tuihuodan641.png';
import tuihuodan642 from './assets/img/tuihuodan642.png';
import peijiansuopei641 from './assets/img/peijiansuopei641.png';
import peijiansuopei642 from './assets/img/peijiansuopei642.png';
import peijiansuopei643 from './assets/img/peijiansuopei643.png';
import jianglixize651 from './assets/img/jianglixize651.png';
import tousushouliren652 from './assets/img/tousushouliren652.png';
import wangzhangweihuliucheng from './assets/img/wangzhangweihuliucheng.png';
import kefucaozuoliucheng from './assets/img/kefucaozuoliucheng.png';
import erpshiyongpeixunliucheng from './assets/img/erpshiyongpeixunliucheng.png';
import erpceshiliucheng from './assets/img/erpceshiliucheng.png';
import xuqiudiaoyanliucheng from './assets/img/xuqiudiaoyanliucheng.png';
import fuhuaxiangmukaifaliucheng from './assets/img/fuhuaxiangmukaifaliucheng.png';
import daxingchefuzhibanbiao from './assets/img/daxingchefuzhibanbiao.png';
import yunhaochefushourufenpeixize from './assets/img/yunhaochefushourufenpeixize.png';
import chefujixiaoticheng from './assets/img/chefujixiaoticheng.png';
import weixiushigukaohebiaozhun1 from './assets/img/weixiushigukaohebiaozhun1.png';
import chexianyewucaozuoliucheng from './assets/img/chexianyewucaozuoliucheng.png';
import chefujianglixize from './assets/img/chefujianglixize.png';
import shiguchejieshouren from './assets/img/shiguchejieshouren.png';
import zhiyezhuang from './assets/img/zhiyezhuang.png';
import haiwaifengongsirenyuanguanli from './assets/img/haiwaifengongsirenyuanguanli.png';
import haiwaifengongsirenyuanguanli1 from './assets/img/haiwaifengongsirenyuanguanli1.png';
import haiwaifengongsirenyuanguanli2 from './assets/img/haiwaifengongsirenyuanguanli2.png';
import houqinbaozhangliucheng from './assets/img/houqinbaozhangliucheng.png';
import taizhangguanli from './assets/img/taizhangguanli.png';
import yunhaojingpin from './assets/img/yunhaojingpin.png';
import jingpinjiagebiao from './assets/img/jingpinjiagebiao.png';
import yunhaojingpin1 from './assets/img/yunhaojingpin1.png';
import zhiyezhuang1 from './assets/img/zhiyezhuang1.png';
import zhiyezhuang2 from './assets/img/zhiyezhuang2.png';
import zhiyezhuang3 from './assets/img/zhiyezhuang3.png';
import zhiyezhuang4 from './assets/img/zhiyezhuang4.png';

class Section$ extends Component {
    showDrawer = (data) => {
        this.props.enclosureShow(data.target.id,data.target.title)
    }

    render(){
        return(
<div style={{textIndent: '2em'}}>
    <div style={{textAlign: 'center'}}>
        <br/>
        <h1 name="0-5" className="point" id="0-5">第六章 营销管理制度</h1></div>
    <div style={{textIndent: '2em'}}>
        <br/>
        <h2 name="0-5-0" className="point" id="0-5-0">一、 通用条款（适用于集团公司各单位）</h2>
        <h3 name="0-5-0-1" className="point" id="0-5-0-1">1、 规定作业管理细则</h3>
        <h4 name="0-5-0-1-0" className="point" id="0-5-0-1-0">1.1 月会、周会、晨夕会管理细则</h4>
        <p>为加强对集团公司各管理公司/中心和支持/监管各部室的月会、周会、晨夕会的管理，特此制定本会议要求，各项会议需准时、高效、高质的召开，参会人员认真严谨。
            </p>
            <h4>各项例会具体要求如下：</h4>
            <h4>一、月会</h4>
            <p>1.召开机构：以各管理公司/中心、支持/监管各部室为单位召开</p>
            <p>2.召开负责人：各管理公司/中心总经理、支持/监管各部室的总监或经理级领导</p>
            <p>3.参会人员：各管理公司/中心和支持/监管各部室所有人员</p>
            <p>4.会议方式：可采取现场+视频方式</p>
            <p>5.召开时间：在每月总裁办公会结束后的次日（第一个工作日）及时召开，具体时间可由会议召开负责人自行调整，以不耽误正常工作为原则，尽量选择在下班时间或晚上召开，总时长不超3个小时。</p>
            <p>6.会议纪要上传时间：月会结束后的次日（第一个工作日）完成提报。</p>
            <h4>二、周会</h4>
            <p>1.召开机构：以各事业部、品牌部、子公司等独立核算单位和支持/监管等各部室为单位召开。</p>
            <p>2.召开负责人：各事业部、品牌部、子公司和支持/监管等各部室的总监或经理级领导</p>
            <p>3.参会人员：各事业部、品牌部、子公司和支持/监管等各部室所有人员</p>
            <p>4.会议方式：现场+视频召开</p>
            <p>5.召开时间：每周一早8:00-9:00，总时长不超过1小时，依据内容可提前结束。</p>
            <p>6.会议纪要上传时间：每周一17:30之前完成提报。</p>
            <p>7.备注：需召开月会的当周不开周会，只开月会。</p>
            <h4>三、晨夕会</h4>
            <p>1.召开机构：以各部门（中心库、仓储、物流等相同工作属性的人员）为单位召开，依据各部门业务特点自行选择召开晨会或夕会。</p>
            <p>2.召开负责人：相同工作属性的负责人</p>
            <p>3.参会人员：相同工作属性的人员</p>
            <p>4.会议方式：现场召开</p>
            <p>5.召开时间：晨会每日早8:00-8:20，总时长不超过20分钟。</p>
            <p> 夕会每日17:00-17:20，总时长不超过20分钟。</p>
            <p>6.会议纪要上传时间：晨会会议纪要当日12:00前完成提报；</p>
            <p>夕会会议纪要每日20:00前完成提报。</p>
            <p>7.备注：每周一不开晨会，只开周会。</p>
            <h4>四、会议考核标准</h4>
            <p>办公室将对各管理公司/中心和各支持/监管部室的各项例会进行考核。月会、周会需要全程录像，并于会议结束后的规定时间内，由指定会议提报人员将会议纪要上传至钉钉—审批—会议板块，会议视频自行存档并接受办公室随时调取审查。</p>
            <p>晨/夕会、周会漏开考核会议“召开负责人”100分/次，会议漏报考核“提报人员”20分/次，按时提报奖励5分/次（痕迹）；</p>
            <p>月会会议漏开考核会议“召开负责人”200分/次，会议漏报考核“提报人员”50分/次，按时提报奖励5分/次（痕迹）；</p>
            <p>会议纪要敷衍了事、质量不合格，考核“提报人员”20分/次；会议无故缺席考核当事人50分/次。</p>
            <h4>说明：</h4>
            <p>会议“召开负责人”不等于“会议主持人”，“召开负责人”有特殊情况不在时可提前指定有条件临时主持会议的人。会议负责人要提前定向，会议主持人代为传达。会议“召开负责人”为会议的完整召开负全面责任。</p>
            <p>会议“提报人员”不等于“会议记录员”，“提报人员”有特殊情况不在时可提前指定有条件的人代为提报，并确保代提报人能及时优质的完成会议提报。</p>
            <br/>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure61' title="《云豪集团各部门月会周会晨夕会汇总表》" onClick={(value)=>this.showDrawer(value)}>《云豪集团各部门月会周会晨夕会汇总表》</a></div>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure62' title="《会议纪要模板》" onClick={(value)=>this.showDrawer(value)}>《会议纪要模板》</a></div>
            <br/>
        <h4 name="0-5-0-1-1" className="point" id="0-5-0-1-1">2.2 日报、周报、月报管理细则</h4>
        <p>云豪集团全体人员需严格依照SMART原则/5W原则，认真及时地将日报、周报、月报提报至办公软件系统指定板块，为加强对全员周报月报管理，特制定如下管理细则：</p>
            <p>1、适用人员</p>
            <p>日报：管理公司各事业部/品牌部要求交日报的人员</p>
            <p>周报/月报：全体人员（国内全体人员和海外分公司中国籍员工）</p>
            <p>2、提报路径：“钉钉”→常用应用“日志”模块→日报/周报/月报</p>
            <img src={zhoubaotisong} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/>
            <br/>
            <p>3、提报时间：日报需在当天22:00之前完成提报；</p>
            <p>周报需在本周日22:00之前完成提报；</p>
            <p>月报：副总监级以上需在当月总裁办公会的前一天完成提报；</p>
            <p>其他人员需在次月1日之前完成提报（交月报的当周不需交周报）。</p>
            <p>4、考核对象：办公室负责集团全体人员周报、月报考核，将规定作业动态积分提报至人力资源部。其中，职级5级以上人员（含5.0级）的月报由办公室进行考核，5级以下人员月报可由各管理公司/中心/部室依据内部管控细则自行考核。</p>
            <p>5、考核标准：</p>
            <br/>
                <img src={kaohebiaozhun} alt="" style={{width  : '700px',display: 'block',margin : '0 auto'}}/> 
            <br/>
            <h3 name="0-5-0-2" className="point" id="0-5-0-2">第三节 其他规定作业管理细则</h3>
        <p>为及时有效的对集团公司各项通知上传下达，要求全体人员对纪律检查委员会、办公室、人力资源部等支持或监管机构在钉钉办公系统中所下发的各项通知及文件务必在24小时内进行查阅，并认真解读。</p>
        <p>对未按时查阅者，将进行积分考核，考核标准为10分/天。</p>
        <h3 name="0-5-0-2" className="point" id="0-5-0-2">2、 销售逻辑链及鱼池理论解析</h3>
        <h4 name="0-5-0-2-0" className="point" id="0-5-0-2-0">第一节 销售技巧解析</h4>
        <img src={xiaoshoujiqiao} alt="" style={{width  : '700px',display: 'block',margin : '0 auto'}}/>
        <h4 name="0-5-0-2-1" className="point" id="0-5-0-2-1">第二节 销售逻辑链</h4>
        <img src={xiaoshouluojilian} alt="" style={{width  : '700px',display: 'block',margin : '0 auto'}}/>
        <br/>
        <h4 name="0-5-0-2-2" className="point" id="0-5-0-2-2">第三节 鱼池理论解析</h4>
        <br/>
        <img src={yuchililun} alt="" style={{width  : '100%',minWidth:'00px',display: 'block',margin : '0 auto'}}/>
        <br/>
        <p><strong>鱼池理论：</strong>是云豪集团营销部门客户营销的基本方法，适用于云豪集团每一位营销人员，同时也适应于每一位员工。所有营销人员必须照此标准执行。</p>

        <h4>一 收集客户信息</h4>
            <br/>
                <img src={kehuxinxi61} alt="" style={{width  : '500px',display: 'block'}}/> 
            <br/>
            <p>1、 老客户信息：过往积累的老客户，例如：已与我司产生业务的，购买过车辆、配件或维修</p>
            <p>2、 自我认知：自我认为有可能购买的客户，走出去链接（俗称“扫街”）。例如：物流园中的某一条专线公司，渣土清运车队，行业客户等。</p>
            <p>3、 道听途说：从不同行业、不同人群中碰到的购买信息。例如客户转介绍或集团内信息提供；</p>
            <p>4、 网络传媒：从电子信息、互联网上收集到的购买信息，例如招投标信息等。</p>
            <p>5、 以上所有客户信息（即1#鱼池），客户编码统一列为D级（D级客户每三个月完成一次筛选）</p>
            <h4>二、筛选有用客户信息（有用和有效）</h4>
            <p>1、 筛选有效客户信息，对现有产品或服务有需求或潜在需求即为有效客户信息。</p>
            <br/>
                <img src={kehuxinxi62} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>2、 集团非销售岗位人员提供有效整车销售购买信息的，对于有效信息提供人奖励积分100分/次（非集团公司代理品牌，并与销售系统内现有客户重合的算无效信息；非销售岗位人员将有效购买信息提供至卡车业务管理公司销售支持。</p>
            <p>3、 集团公司非保险岗位推销商业保险完成销售的，相应人员奖励200分/次。</p>
            <p>4、 竞争对手，视为我们的有用客户信息（如北京市内其它红岩服务站或销售公司，亦或Scania与Benz这样的竞争对手），每两个月试着沟通一次，争取合作共赢（如，竞争对手无法满足客户要求时可以转到我司进行跟进）。</p>
            <br/>
                <img src={jingzhengduishou62} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>5、 以上所有客户信息（即2#鱼池），客户编码统一列为C级（C级客户每二个月完成一次筛选）。</p>
            <h4>三、整理有效客户信息</h4>
            <p>1、 有需求-有业务，即客户有相应产品或服务的购买需求，并已与我司有业务往来；</p>
            <br/>
                <img src={youyou61} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>2、 有需求-无业务，即客户有相应产品或服务的购买需求，未与我司有业务往来；需要销售经理激发客户的需求发生业务。</p>
            <br/>
                <img src={youwu61} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>3、 有潜在需求-目前无业务，即客户有相应产品或服务的购买潜在需求，未与我司有业务往来；需要品牌总监协同销售经理，创造销售的可能性，发生业务。</p>
            <br/>
                <img src={muyou61} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>四、梳理跟进客户信息</p>
            <p>1、 全部份额，我司产品占客户相应需求的全部份额，需要市场经理实时关注客户需求及对我方不满意的地方；</p>
            <br/>
                <img src={quanfene61} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
            <p>2、 部分份额，我司产品占客户相应需求的部分份额，其它部分由其它公司占有，需要市场经理提供更有效的解决方案（原有方案改进或者重新量身定制解决方案，外协采购利用社会资源也是有效的手段之一），提升客户满意度，增加我司所占份额；</p>
            <br/>
                <img src={bufene61} alt="" style={{width  : '400px',display: 'block'}}/> 
            <br/>
        <h3 name="0-5-0-3" className="point" id="0-5-0-3">3、 客户接洽和拜访跟进管理流程及标准</h3>
        <h4 name="0-5-0-3-0" className="point" id="0-5-0-3-0">3.1 客户接洽流程及标准</h4>
        <h4 name="0-5-0-3-0-0" className="point" id="0-5-0-3-0-0">3.1.1 客户接洽形象管理</h4>
        <p>1、职业装包括：销售正装、客服接待正装、冬季/夏季时装、户外装、休闲装、领带、围脖、帽子、手套、衬衣等。</p>
            <p> 2、化妆与修饰：女士淡妆，束发，严禁素颜和浓妆，男士头发长度不应接触衬衫领口。</p>
            <p>3、要求：客户服务专员在工作时间必须穿着对应岗位的职业装，职业装是云豪集团对每一位员工的基本规范之一，员工的职业形象是衡量本人是否是云豪合格员工的基本要素之一。</p>
            <p>考核：监察部考核管理公司总监及以上100分/项，对应岗位员工50分/项。</p>
        <h4 name="0-5-0-3-0-1" className="point" id="0-5-0-3-0-1">3.1.2 接洽前准备工作</h4>
        <p>（一）商务礼仪</p>
            <p>1、会面礼仪</p>
            <p>（1）随身携带名片用于与对方交换，了解对方身份；</p>
            <p>（2）主动和对方握手</p>
            <p>2、商务接待礼仪</p>
            <p>（二）资料准备，将所有厂家彩页集中放置，销售代表配齐销售工具。</p>
            <p>（三）专业知识准备</p>
            <p>1、企业知识。公司的介绍，公司的销售政策，例如服务的项目。</p>
            <p>2、产品知识。即了解生产汽车的厂家、品牌、各款车的性能、功能和配置。</p>
            <p>3、市场知识。包括这款汽车在市场上的占有率，与竞争车型的对比、优劣情况等等。</p>
            <p>4、用户知识。用户知识主要包括客户群体、消费习惯、客户的购买动机、客户的爱好 、客户的决策人购买力等等。比如，客户的时效性，货源结构，运营线路，公司规模等。</p>
        <h4 name="0-5-0-3-0-2" className="point" id="0-5-0-3-0-2">3.1.3 电话接洽</h4>
        <p>（一）电话礼仪</p>
            <p>1、接听电话的基本规范</p>
            <p>（1）电话铃响在三声之内接起,保持良好的坐姿与客户交流；</p>
            <p>（3）电话机旁准备好纸和笔进行记录；</p>
            <p>（4）明确记录客户信息并积极邀请来店或约上门拜访；</p>
            <p>（5）电话结束时，应感谢客户致电，待对方挂断电话再挂电话；</p>
            <p>（6）电话结束后，填写来电客户登记表。</p>
            <p>（二）基本话术</p>
            <p>1、接听电话与问候客户</p>
            <p>2、确认客户及车辆信息</p>
            <p>3、聆听客户需求</p>
            <p>4、确认客户预约来店参观时间</p>
            <p>5、移交销售代表接待并告知</p>
            <h4>四、来店接待</h4>
            <p>（一）前台接待</p>
            <p>1、由前台欢迎客户来店；</p>
            <p>2、前台接待询问对方来店意图；</p>
            <p>3、前台联系销售支持接待客户；</p>
            <p>4、销售支持接待客户</p>
            <p>（1）带客户参观展厅和服务车间；</p>
            <p>（2）参观展车并移交销售代表讲解；</p>
            <p>销售代表讲解车辆，登记客户信息；</p>
        <h4 name="0-5-0-3-0-3" className="point" id="0-5-0-3-0-3">3.1.4 上门拜访</h4>
        <p>（一）基本流程</p>
            <p>1、寻找客户</p>
            <p>（1）产品定位</p>
            <p>（2）目标客户锁定</p>
            <p>2、拜访计划</p>
            <p>（1）提前预约拜访</p>
            <p>（2）确定拜访时间</p>
            <p>（3）确定拜访目的</p>
            <p>（4）总结拜访内容</p>
            <p>考核：以上规定适用于集团公司所有营销人员，有不符标准的考核50分/项。</p>
        <h4 name="0-5-0-3-0-4" className="point" id="0-5-0-3-0-4">3.1.5 接洽标准</h4>
        <h4>1、面对面接洽流程标准</h4>
        <br/>
            <img src={jieqiabiaozhun63} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>2、非面对面客户接洽流程标准</h4>
        <br/>
            <img src={jieqiabiaozhun61} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>3、客户服务科流程标准</h4>
        <br/>
            <img src={jieqiabiaozhun62} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4 name="0-5-0-3-1" className="point" id="0-5-0-3-1">3.2 客户拜访跟进说明</h4>
        <h4 name="0-5-0-3-1-0" className="point" id="0-5-0-3-1-0">3.2.1 行业客户分析</h4>
        <p>1、根据所在部门负责行业销售区域分析有哪些客户？</p>
            <p>2、哪些采购过？（属于老客户，建立联系，维护客户关系，挖掘更多需求）</p>
            <p>3、哪些采购竞争品？（重点跟进，建立联系，多次拜访，维护客户关系，转变客户观念）</p>
            <p>4、哪些一直在采购国产产品有可能采购进口？（定期走访，重点讲述进口车性能优势，引导可少量购买进口车尝试，引导用户观念转变）</p>
        <h4 name="0-5-0-3-1-1" className="point" id="0-5-0-3-1-1">3.2.2 联系方式</h4>
        <p>1、公司现有联系人信息；</p>
            <p>2、公司其他同事提供联系人；</p>
            <p>3、通过身边的亲戚朋友提供联系人；</p>
            <p>4、通过改装厂人员提供联系人；</p>
            <p>5、通过114或12580等客服电话查询；</p>
            <p>6、通过要查询的公司网页查询联系方式；</p>
        <h4 name="0-5-0-3-1-2" className="point" id="0-5-0-3-1-2">3.2.3 预约方式方法</h4>
        <p>1、电话预约；</p>
            <p>2、短信预约；</p>
            <p>3、微信预约；</p>
            <p>4、通过其他同事或朋友帮忙预约；</p>
            <p>5、到单位门口直接找门卫约见客户；</p>
        <h4 name="0-5-0-3-1-3" className="point" id="0-5-0-3-1-3">3.2.4 拜访前准备资料</h4>
        <p>1、纸质版和电子版产品资料；</p>
            <p>2、带IVECO标志的小礼品；</p>
            <p>3、提前了解要拜访人姓名和职位，并想好如何称呼；</p>
            <p>4、提前查询单位所在地址（办公地址有可能会变更）；</p>
            <p>5、提前查询到达客户单位交通方式，计算好时间；</p>
            <p>6、提前查好见面周边的酒店、饭店、咖啡厅等信息；</p>
        <h4 name="0-5-0-3-1-4" className="point" id="0-5-0-3-1-4">3.2.5 面访交流</h4>
        <p>1、微笑打招呼；</p>
            <p>2、递名片，自我介绍；</p>
            <p>3、介绍产品；</p>
            <p>4、询问现有车辆具体情况，如保有量，车型、品牌、国产和进口比例；</p>
            <p>5、多听客户需求，商谈车型匹配事宜；</p>
            <p>6、了解采购较多改装厂名称，机关息情况；</p>
            <p>7、通过交流可以了解到竞品信息，以及行业信息； </p>
            <p>8、适当机会添加微信或邮箱；</p>
            <p>9、了解客户详细姓名、职务等（有可能晋升或是换部门）</p>
            <p>10、说话得体，注意分寸；</p>
            <p>11、介绍集团公司在北京，重点提接待优势等；</p>
            <p>12、在客户说还要开会或是有其他事，自己要主动说您先忙，下次再来拜访您；</p>
            <p>13、记住客户的办公室位置，方便下次拜访；</p>
        <h4 name="0-5-0-3-1-5" className="point" id="0-5-0-3-1-5">3.2.6 后续跟进</h4>
        <p>1、有采购需求跟进，约客户晚上单独出来坐坐，如果能出来就说明几率大一些，出来后商谈项目进一步事宜；</p>
            <p>2、重要节日赠送礼品与问候；</p>
            <p>3、同时微信互动点赞，通过微信朋友圈了解客户的喜好等事宜；</p>
            <p>4、争取能找到与客户找共同爱好；</p>
            <p>5、拜访完毕后分析此客户等级；</p>
            <p>有采购计划：</p>
            <p>1）通过自己直接与采购决策人交流谈判；</p>
            <p>2）通过公司内领导同事找关系；</p>
            <p>3）通过改装厂销售了解共同推进；</p>
            <p>4）通过与客户关系较好的其他供应商介绍，利润分成推进；</p>
            <p>5）重点跟进，拜访频率增加；</p>
            <p>暂无采购计划：</p>
            <p> 1）定期拜访；</p>
            <p> 2）重点讲解进口底盘车的优势，引导客户尝试选择进口底盘改装；</p>
            <p> 3）培养与客户的关系，为后续的销售做好基础；</p>
            <p> 4）即使目前不购买进口车，争取通过客户转介绍有需求的其他客户；</p>
        <h4 name="0-5-0-3-1-6" className="point" id="0-5-0-3-1-6">3.2.7 报价</h4>
        <p>1、初次报市场销售价格（含税和免税价格）；</p>
            <p>2、采购经理报价比市场价优惠2000元左右（视情况而定）；</p>
            <p>3、总经理、副总经理等领导要求降价时，优惠5000左右（视情况而定）；</p>
            <p>4、要有正规的报价单（包含价格、付款方式、交货期、技术规格编号、报价有效期和币种等信息）</p>
            <p>八、签订合同</p>
            <p>1、重点合同金额、型号、数量、付款方式、交货期、违约条款和技术规格等所有合同内容；</p>
            <p>2、自己修改完合同模板交由销售支持审核，销售支持审核完毕后交由部门负责人审核确认或签字，不同合同模板需要管理公司和财务部审核通过。</p>
        <h3 name="0-5-0-4" className="point" id="0-5-0-4">4、 招投标细则及标准</h3>
        <h4>第一节 总则</h4>
            <p>1、为进一步加强公司市场开发工作，规范投标工作的管理，明确投标过程各环节的责、权、利，充分调动公司及各单位参与市场竟争的积极性，特制定本管理办法。</p>
            <p>2、投标工作必须遵守《招投标法》、《合同法》等法律、规章，执行国家及行业颁布的标維、规范及公司的相关规定。</p>
            <h4>第二节 投标细则及标准</h4>
            <br/>
                <img src={toubiaoxize} alt="" style={{width  : '700px',display: 'block',margin:'0 auto'}}/> 
            <br/>
            <p>1、招标信息收集途径：</p>
            <p> 1.1央企集采招标平台；</p>
            <p> 1.2行业客户集采平台；</p>
            <p> 1.3招标网公示；</p>
            <p> 1.4传统大客户招标信息来源；</p>
            <p>2、招标有效信息梳理：</p>
            <p>2.1集团资源（产品）是否符合招标要求；</p>
            <p>2.2三看一圈：</p>
            <p>对有效招标文件，直接负责人对于招标文件认真审视，斟酌。</p>
            <p>三看：大致过一遍；细致过一遍；重点过一遍；</p>
            <p>一圈：圈定重点。</p>
            <p>3、确定标书购买权限:</p>
            <p> 由标书制作独立核算单位出具初步意见，由管理公司总经理最终审核通过。</p>
            <p>4、成立临时投标小组、明确负责人：</p>
            <p> 4.1商务部分至少阅读3遍，找出偏离项（减分点），找出我们的加分点。</p>
            <p> 4.2技术部分至少阅读3遍，找出偏离项（减分点），找出我们的加分点。</p>
            <p> 4.3商务部分由法务把关。</p>
            <p> 4.4其他资质联系财务部门落实。</p>
            <p>5、分工负责、落实</p>
            <p>6、电子版标书合成</p>
            <p> 8、按招标公司要求确定字体及格式，若无特殊要求，原则上按照宋体小四号字体进行打印。</p>
            <p>7、总经理价格确认并做最后标书审核，至少审核2遍。</p>
            <p>8、打印标书要求</p>
            <p> 8.1选择大型图文制作室：例：长虹桥天佳，专业，会员价合适。</p>
            <p> 8.2正副本均为彩色打印，纸张选择A4、 80g纸。</p>
            <p> 8.3封皮要求:铜版纸，颜色:1)白色；2）蓝色：3）红色。</p>
            <p> 8.4标书力求醒目、美观、容易翻阅，同时节约成本。</p>
            <p> 8.5标书打印时间必须是投标截止日前24小时完成。</p>
            <p> 8.6标书在招标公司要求的份数之上多打印一份自留。</p>
            <p> 8.7原则上标书单面打印。</p>

            <p>9、签字、盖章</p>
            <p>9.1签字：严格按招标文件要求清晰签到所需位置，并在每页小签。</p>
            <p>9.2用章：严格按招标文件要求清晰盖到所需位置（如需加盖骑缝章，按要求盖章），公章谨防盖错位置或用非投标公司公章。</p>
            <p>10、递交标书</p>
            <p>11、严格按照招标公司递交程序进行递交。</p>
            <p>12、电子/纸质标书存档</p>
            <p>投标有成功有失败，前期分析工作是重点，一切以目标（参与具体投标的意义）为导向，节约不必要的开支及时间的浪费。做到行之有效。</p>
        <h3 name="0-5-0-5" className="point" id="0-5-0-5">5、 公司重大活动/会议的规范细则</h3>
        <h4>第一节 总则</h4>
            <p>为进一步加强公司重大活动、会议的组织及参加工作，规范重大活动、会议流程的管理，明确会议过程各环节的责、权、利，充分调动公司及各单位参与市场竟争的积极性，特制定本管理办法。</p>
            <h4>第二节 组织及参加规范细则</h4>
        <h4 name="0-5-0-5-0" className="point" id="0-5-0-5-0">5.1 成立工作组</h4>
        <p>每次大型活动、会议成立专项筹备小组，负责前期筹备（会前）、过程跟踪（会中）及后续处理工作（会后）。</p>
            <p>组长：发起部门负责人。特别重大活动、会议的，由董事长指定领导班子成员担任。</p>
            <p>组员：发起部门及相关部门的部门中层及骨干人员</p>
            <p>（包括物资、场地、设备、考勤、资料管理等责任人）</p>
        <h4 name="0-5-0-5-1" className="point" id="0-5-0-5-1">5.2 信息确认</h4>
        <p>1、确定活动、会议的时间、地点及活动主题内容；</p>
            <p>2、确定活动参与人员姓名、职务、部门/单位；</p>
            <p>3、确定活动、会议的详细流程安排，明确相关工作人员职责，制定《xx活动工作安排表》。</p>
        <h4 name="0-5-0-5-2" className="point" id="0-5-0-5-2">5.3 场地、物资安排</h4>
        <p>1、至少提前三天根据活动、会议需求预定场地，并提出场地布置方案。</p>
            <p>2、大型活动提前半天、会议提前半小时调试现场音响设备，保证所有设备在活动、会议举行过程中能正常运作。</p>
            <p>3、至少提前一天确定是否需要做水牌、横幅，如有需要尽快确定内容，并即日制作准备好。</p>
            <p>4、至少提前一天根据活动、会议需要准备好名牌、鲜花、礼花、茶水、水果、活动、纸巾、桌椅、流程表等，所有物资提前半天到位，并按要求提前布置好场地。</p>
        <h4 name="0-5-0-5-3" className="point" id="0-5-0-5-3">5.4 车辆安排</h4>
        <p>1、至少提前三天确定活动路线，做好相应接送、引领人员的工作安排。</p>
            <p>2、至少提前两天根据活动级别、活动人数，确定使用车辆种类、数量，并于车辆确认后联系司机落实时间、行走线路。</p>
            <p>3、如活动需要接送客人、集团领导，则提前根据发起部门或客人指定联系人提供的信息，查询需接送人员是否按时出发，飞机、火车有无晚点、延误等其他情况，并且进一步落实人员有无变化，做好相应的迎接准备。同时，提前预定机场贵宾厅；提前沟通火车站出站安排；如客人自驾车来访，需提前安排引领人员及引领车辆，提前确定接头地点并熟悉行车线路。</p>
        <h4 name="0-5-0-5-4" className="point" id="0-5-0-5-4">5.5 住宿安排</h4>
        <p>1、根据住宿人员的职务、级别、重要程度事前预定合适的酒店并安排合适的住房；</p>
            <p>2、根据住宿人员对楼层、朝向的特殊要求，合理安排房型及房间位置；确定房号、入住天数，提前做好房卡。</p>
            <p>3、提前做好叫早及早餐安排，做好退房及返程的信息确认工作。</p>
        <h4 name="0-5-0-5-5" className="point" id="0-5-0-5-5">5.6 用餐安排</h4>
        <p>1、根据活动的内容、性质确定用餐标准，并预定合适的用餐酒店。</p>
            <p>2、提前检查用餐房间的环境布置、座次安排、空调、通风、灯光效果、音响、座位间隔等，安排专人负责台卡的制作和摆放。</p>
            <p>3、根据用餐标准、参与领导或客人的喜好、习惯、民族特点安排合适的菜式。</p>
            <p>4、根据活动需要，提前准备合适的酒水，并安排专人提前将酒水运往用餐地点。</p>
        <h4 name="0-5-0-5-6" className="point" id="0-5-0-5-6">5.7 资料管理</h4>
        <p>1、安排专人负责活动资料管理，包括文字资料、图片资料、视频音频资料的收集、整理、归档。</p>
            <p>2、活动资料要求做到准确、全面、重点突出、有代表性。</p>
        <h4 name="0-5-0-5-7" className="point" id="0-5-0-5-7">5.8 风险保障</h4>
        <p>1、水电保障：</p>
            <p>（1）室内活动：提前联系相关接口，确保场地当天水电供应正常，如提前获知当天停水、停电且活动不得改期，需尽可能跟场地负责人协调临时用水、用电。如现场无法提供临水、临电，确保现场通风、采光工作要做好。</p>
            <p>（2）户外活动：提前联系相关接口，确保场地当天水电供应正常，并安排专人评估当天用水、用电是否超负荷，并派专人驻点电站保障。如提前获知当天停水、停电且活动不得改期，跟场地负责人协调必须提供临水、临电，并根据临电负荷能力调整器材使用方案。</p>
            <p>2、设备保障：</p>
            <p>做好提前调试准备工作，如遇故障马上更换仪器，确保活动过程设备运作正常。</p>
            <p>针对现场设备准备一份备用方案，以应对设备中途出现故障等问题。保障活动、会议不会因临时故障问题被中断。</p>
            <p>3、天气保障：</p>
            <p>室外活动提前两天查询天气预报，遇雨天要提前给宾客、领导备伞，并提前为其他参加人员申购一次性雨衣。同时，使用即时短信通知机制，给相关人员发送天气温馨提醒短信。</p>
            <p>4、根据活动、会议实际情况，在前期筹备工作中做好其他风险评估，并准备好相应的应急备案。</p>
        <h4 name="0-5-0-5-8" className="point" id="0-5-0-5-8">5.9 纪律要求 </h4>
        <p>1、重大会议、活动原则上不予以请假，如因特殊情况需要请假，须提前一天向发起部门提交部门负责人签字请假条，汇总呈董事长审批后方能请假。</p>
            <p>2、与会人员须全部提前30分钟到达现场签到，参与大型户外活动要提前半小时到1小时到达现场，并按照指定位置进场等候，确保活动、会议能依时进行。</p>
            <p>3、参加人员须具备前瞻性，活动前要做好充分的风险评估，避免因堵车等原因而导致迟到。</p>
            <p>4、会议、活动开始前遇到突发性重要工作，需提前请示董事长并向会议、活动组织部门报备。</p>
            <p>5、会议及过程要求严肃安静的重大活期间，参加人员要自觉遵守现场秩序，须将通讯工具关闭或置于无声状态，不得随意接打电话或擅自离开现场处理其他无关的事务，不得在室内抽烟、来回走动、交头接耳、打瞌睡等。</p>
            <p>6、如当次会议、活动有着装要求，全体参与人员必须严格遵守。</p>
            <p>7、会议、活动组织部门提前做好考勤管理工作。登记好迟到、早退、缺席、会议接听电话等违纪情况，会后统一上报董事长处理。</p>
        <h4 name="0-5-0-5-9" className="point" id="0-5-0-5-9">5.10 违规处理</h4>
        <p>1、迟到15分钟以内，处以通报批评的处罚；</p>
            <p>2、迟到15分钟以上半小时以内，处以通报批评及扣罚当月200分的处罚。</p>
            <p>3、迟到半小时以上一小时以内，处以通报批评及扣罚当月300分的处罚。</p>
            <p>4、迟到一小时以上，处以通报批评及扣罚当月500分的处罚。</p>
            <p>6、无故早退，处以通报批评及扣罚当月200分的处罚。</p>
            <p>7、无故缺席，处以通报批评及扣罚当月500分的处罚。</p>
            <p>8、违反活动着装要求者，处以通报批评及扣罚当月200分的处罚。</p>
            <p>9、会议期间随意走动、交头接耳，处以通报批评及扣罚当月200分的处罚。处以通报批评及扣罚当月500分的处罚。</p>
            <p>10、活动、会议现场喧闹，影响公司形象者，处以通报批评及扣罚当月500分的处罚。</p>
            <p>11、大型会议中多次接听电话，影响会议进行，处以通报批评及扣罚当月500分的处罚。</p>
            <p>12、泄露会议机密内容者，处以通报批评及降一级工资的处罚，情节严重者，处以开除。</p>
        <h4 name="0-5-0-5-10" className="point" id="0-5-0-5-10">5.11 礼仪要求</h4>
        <h4>1、基础礼仪：做到“四守”8个字</h4>
            <p>（1）守时。准时与会，参加所有公司会议及重大活动都必须守时，提前到场，树立个人正面形象。</p>
            <p>（2）守秘。有高度的保密意识，不对外泄露活动、会议上获取的任何信息。</p>
            <p>（3）守规。遵守活动规则，注重场合，对不同对象要守不同规矩。</p>
            <p>（4）守忌。参与活动、会议过程中说话、做事要谨慎，注意别人的禁忌。</p>
            <h4>2、会议礼仪</h4>
            <p>（1）会前准备要做好，记录工具要备齐，会议精神好传达。</p>
            <p>（2）会议安排要服从，参加会议要准时，考勤记录要严守。</p>
            <p>（3）签到入场稍提早，指定位置就座好，就坐位置往前靠。</p>
            <p>（4）会场秩序自觉守，交头接耳打瞌睡，扰乱秩序绝不许。</p>
            <p>（5）通讯工具要静音，不得随意接电话，擅自离开切不行。</p>
            <p>（6）踊跃发言表观点，中心思想需凸显，做到意赅言又简。</p>
            <p>（7）管好自己手和口，会议材料小心守，机密信息不泄漏。</p>
            <p>（8）会议结束有序离，椅子物品摆整齐，个人物品随身带。</p>

            <h4>3、酒宴礼仪</h4>
            <p>宴前领导杯未起，静坐等候方守礼；</p>
            <p>领导举杯齐祝酒，杯中一滴不能留；</p>
            <p>敬酒长幼要有序，领导敬完方能去；</p>
            <p>敬酒顺序有讲究，年长位高有所求；</p>
            <p>善言观色甚重要，劝挡代酒要得当；</p>
            <p>多人敬一属正常，一敬多人太张狂；</p>
            <p>谦恭有礼惹人喜，杯低三分不失礼；</p>
            <p>酒宴桌上忌私语，众欢同乐方可取；</p>
            <p>自己酒量知大概，慎防酒后人失态；</p>
            <p>紧握酒宴大主题，目的达成齐欢喜！</p>
        <h4 name="0-5-0-5-11" className="point" id="0-5-0-5-11">5.12 后续处理工作（会后）</h4>
            <p>1）总结得与失，总结纪要备案，为后续会议做调整。</p>
            <p>2）汇总、分类客户信息。</p>
            <p>3）制定拜访、跟进计划，分派到相关负责人。</p>
        <h3 name="0-5-0-6" className="point" id="0-5-0-6">6、 全员换岗学习</h3>
        <p>为增强业务链接，促进全员沟通学习及人文关怀，集团公司特此提出全员“换岗学习”，具体内容如下：</p>
        <p>1、营销机构总监级（含）以上的管理人员每周必须亲自到基层一线与基层员工一起工作不低于2小时，以同事的身份、符合一线业务特性的工装实地操作，以达到体验、了解、调研、沟通、人文关怀的目的。</p>
        <p>2、一线场景包括：维修一线、仓库一线、物流一线、销售一线、客服一线。</p>
        <p>3、支持、监管、统计、客服等所有内勤岗位人员（含管理人员）要确保每月不低于2次，每次不低于2小时到营销机构各级岗位各工种的现场，以同事的身份、符合一线业务特性的工装实地操作，以达到体验、了解、调研、沟通、人文关怀的目的。</p>
        <p>4、一线整车及配件销售人员要确保每月不低于2次，每次不低于2小时到维修一线，以同事的身份、符合一线业务特性的工装实地操作，以达到体验、了解、调研、学习、沟通的目的。</p>
        <p>5、“换岗学习”一线场景排序依次为：先本事业部、再本管理公司、后集团其他管理公司，根据实际情况自行安排，总之要到更多的一线岗位去体验、学习，以达到融合、共进的目的。</p>
        <p>6、“换岗学习”是云豪集团每位员工的必修课，要把学习内容写入每个人的月报（积分考核）。</p>
        <h3 name="0-5-0-7" className="point" id="0-5-0-7">7、云豪集团职业装管理细则</h3>
        <p>根据集团公司多品牌经营特性，展现员工精神风貌，树立集团公司良好统一的企业形象，特制定本细则加强员工职业装规范管理。</p>
        <p>1、适用人员：集团公司全体员工</p>
        <p>2、职业装穿着时间：工作期间</p>
        <p>3、职业装要求：不同岗位的云豪员工应规范穿着对应岗位要求的工装及劳保防护用品并恰当佩戴标识，仪态整洁端正，不得穿奇装异服，禁止穿背心、短裤、拖鞋等进入办公区域。</p>
        <h4>&nbsp;&nbsp;&nbsp;4、监督考核：</h4>
        <p>4.1各部门负责人有责任和义务自查本部门员工职业装穿着情况。</p>
        <p>4.2总裁办不定期全体人员进行检查，对未按规定着装的人员将予以通报批评并考核50-100积分/次。</p>
        <h4>&nbsp;&nbsp;&nbsp;5、职业装的具体配置：</h4>
        <img src={zhiyezhuang1} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <img src={zhiyezhuang2} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <img src={zhiyezhuang3} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <img src={zhiyezhuang4} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
 
        {/* <h3>二、职业装的获取方式</h3>
        <h4>&nbsp;&nbsp;&nbsp;第一阶段：现金购买+公司补贴</h4>
        <h4>&nbsp;&nbsp;&nbsp;第二阶段：积分兑换+免费奖励</h4> */}

        <h3>三、此方案为试运营版本，根据第一阶段的运营情况，集团公司有权作出调整。</h3> 
        <br/>
        <h3 name="0-5-0-8" className="point" id="0-5-0-8">8、云豪精品管理细则（第一阶段）</h3>
        <p>为提升企业外在形象，加强企业品牌宣传，云豪精品店特定制云豪精品助力全员营销，第一阶段已采购陶瓷茶具、车载急救包、车载手机支架、车载加湿器、蓝牙音箱等，现就云豪精品的管理细则通知如下：</p>
        <h4>一、云豪精品展示</h4>
        <h4>礼品一：陶瓷茶具</h4> 
        <img src={yunhaojingpin} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <h3>二、云豪精品价格表</h3>
        <img src={jingpinjiagebiao} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <h3>三、云豪精品申请方式</h3>
        <p>1.馈赠客户</p>
        <p>1.1费用说明：</p>
        <p>员工拜访客户，依据业务需求向部门总监及上级领导申请领取云豪精品，按照公司内部记账价格（成本价格），计入部门费用。</p>
        <p>1.2申请流程：</p>
        <p>以部门为单位，由统计人员汇总礼品申请单，经部门总监及上级领导签字后，到财务部开销售单（内部记账），每月统一申请一次（有大量需求时也可立即办理），统计持财务部销售单，到资产部领取。</p>
        <img src={yunhaojingpin1} alt="" style={{width  : '700px',display: 'block',margin : '0 auto'}}/> 
        <p>2.内部员工采购</p>
        <p>第一阶段：员工依据个人喜好选择云豪精品，上报给部门统计，统计到财务部开销售单（按内部员工采购价（成本价格）统一缴费，每月统一申请一次（有大量需求时也可立即办理）。</p>
        <p>第二阶段：积分兑换或免费奖励。</p> 
        <h3>四、此方案为试运营版本，根据第一阶段的运营情况，集团公司有权做出调整。</h3>                          
        <br/>
        <h2 name="0-5-1" className="point" id="0-5-1">二、专用条款 （各营销机构内部管控流程及标准）</h2>

        <h2 name="0-5-1-0" className="point" id="0-5-1-0">卡车业务管理公司</h2>
        <h4 name="0-5-1-0-0" className="point" id="0-5-1-0-0">2021年卡车业务管理公司组织机构图及管理层人事安排</h4>
        <h4>一、卡车业务管理公司组织机构图</h4>
        <img src={kache11} alt="" style={{width  : '500px',display: 'block',margin : '0 auto'}}/> 
        <h4>二、卡车业务管理公司支持监管机构管理层人事安排：</h4>
        <p><strong>1、总经理：</strong>武晓亮，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人。主管斯堪尼亚北京公司、天津斯堪尼亚、石家庄斯堪尼亚、沈阳斯堪尼亚、专用车底盘事业部、新疆公司；监管整车品牌营销一部、整车品牌营销二部、天津红岩品牌部。
        </p>
        <p><strong>2、副总经理：</strong>范晓康，主管整车品牌营销一部、整车品牌营销二部、天津红岩品牌部，对总经理汇报工作。</p>
        <p><strong>3、副总经理：</strong>车立民，主管专用底盘事业部，监管进口整车营销，对总经理汇报工作，服从总经理的工作安排。</p>
        <p><strong>4、副总经理：</strong>黎勇，主管金融保险部，对总经理汇报工作，服从总经理的工作安排。</p>
        <p><strong>5、总经理助理：</strong>杨忠林，负责卡车业务管理公司各地区公司的民品销售支持工作，斯堪尼亚零售业务牵引车价格管控，负责销售人员的培训，对总经理汇报工作。</p>
        <p><strong>6、行政部 专员：</strong>赵美玲，协调卡车业务管理公司各部门人员招聘、职业规划、职业发展、员工工作心态及状态收集、疏导，跟进员工培训计划，对接集团人力资源部和办公室的工作。</p>
        <p><strong>7、销售支持部 专员：</strong>房燕素、杨洋，管理监督卡车业务管理公司所属各公司销售支持人员工作，监管各公司整车销售版块经营数据的准确性，整车库存的准确性，整车销售版块的流程及规定的执行，整车销售合同的初审，向总经理汇报。</p>
        <p><strong>8、统计部 负责人：</strong>连亚路（科级），管理监督卡车业务管理公司所属各公司统计人员工作，监管各公司售后服务版块经营数据的准确性，库存的准确性，部门出单的及时性，应收账款按照公司规定执行等，售后服务版块的流程及规定的执行，向集团公司财务部及总经理汇报。 </p>
        <p><strong>9、服务支持部 负责人：</strong>陈志刚（科级），负责对接专用车、依维柯、汕德卡改装支持工作； </p>
        <p><strong>10、培训科：</strong>负责统筹、安排卡车业务管理公司内部的培训工作（技术培训、销售培训、能力培训等），协调卡车内部讲师资源，负责卡车内部的技术培训工作，负责卡车公司服务版块人员技术支持工作。</p>
        <p><strong>11、金融保险部 负责人：</strong>黎勇，主管金融保险部工作，管控风险，对总经理汇报工作，服从总经理的工作安排。</p>
        <p><strong>    保险业务专员：</strong>莫日根（科级），主管保险业务，对金融保险部负责人汇报工作，并接受上级领导的工作安排。</p>
        <p><strong>12、集团客户部 负责人：</strong>范晓康（兼），负责国内行业大客户的销售工作，向总经理汇报工作。</p>
        <p><strong>&nbsp;  集团客户专员：</strong>盛凝波，负责维系国际大客户（央企、国企），收集集团客户整车、配件、服务采购招标信息，向对应品牌交付对应产品的采购需求，项目的投标工作，完成既定销量目标，向卡车公司分管副总经理汇报工作，服从上级领导的工作安排。  </p>
        <h4>三、卡车业务管理公司营销机构管理层人事安排：</h4>
        <p><strong>1、斯堪尼亚北京公司 总监：</strong>刘成志（二级），对卡车公司总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>2、天津斯堪尼亚 负责人：</strong>吴苏腰拉吐（副总监主持工作），对卡车公司总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>3、石家庄斯堪尼亚 总监：</strong>蔺帅（一级），对卡车公司总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>4、沈阳斯堪尼亚 总监：</strong>张雨（一级），对卡车公司总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>5、专用底盘事业部 总监：</strong>车立民（三级），对卡车公司总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>6、整车品牌营销一部 第一负责人：</strong>李超（副总监主持工作），对卡车公司主管副总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>&nbsp; 整车品牌营销二部 负责人：</strong>第二责任人：刘全华（副总监），对部门第一负责人汇报工作，服从上级领导工作安排。</p>
        <p><strong>7、整车品牌营销二部 负责人：</strong>张建春（副总监主持工作），对卡车公司主管副总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>&nbsp; 副总监：</strong>孟鉴霖，对部门负责人汇报工作，服从上级领导工作安排。</p>
        <p><strong>8、天津红岩品牌部 总监：</strong>武文栋（二级），对卡车公司主管副总经理汇报工作，服从上级领导工作安排。</p>
        <br></br>
        <h4 name="0-5-1-0-1" className="point" id="0-5-1-0-1">二、卡车业务管理岗位职责及业务范围</h4>
        
        <h4>卡车管理公司：独立考核单位</h4>
        <h4>公关委员会</h4>
        <p>定期召开会议，汇总市场信息，产品，分析市场，重要项目跟进进度汇报，以客户需求为基础制定应对方案；</p>
        <p>成员：王云厅（牵头），集团公司总监级以上人员均为委员，根据具体业务临时召集。</p>
        <h4 name="0-5-1-0-1-0" className="point" id="0-5-1-0-1-0">1. 卡车业务管理公司</h4>
        <h4>1.1集团客户部</h4>
        <p>负责维系集团客户，收集集团客户整车、配件、服务采购招标信息，向对应品牌交付对应产品的采购需求，各品牌按照公关部及客户需求制定投标方案及相应投标文件，重要项目需通过公关委员会审核相应方案；</p>
        <h4>1.2行政部</h4>
        <p>负责卡车管理公司人力资源，主要负责管理公司内的岗位需求招聘，人员职级晋升标准的制定及实施，人员解聘，
        对接集团公司人力资源（校企合作人才）的管理公司接收工作，管理公司内职工的个人发展规划工作，定期向管理公司总经理及各部门反馈员工工作状态；</p>
        <h4>1.3统计部</h4>
        <p>整合管理公司各公司、部门统计人员，成立统计工作群，协调公司内所有统计人员对各公司、部门日常服务结算，
            出入库，晨会，夕会，周会，月会，工作标准的执行情况进行日常监督；各部门统计人员向统计部汇总当天会议纪要，
            标准执行情况；关于会议标准各项会议管理公司会统一要求各项会议必须讨论的内容，其它会议项目由各公司、部门自行添加，标准随后会以通知形式下发；</p>
        <p>出具各公司月报提交时间、工资表提交时间、管理公司月会参加情况等要求，统一卡车管理公司管理考核规定，做汇总向卡车管理公司总经理提报及对接财务部考核；
        统筹卡车公司资源对接网络营销部门。</p>
        <h4>1.4服务支持部</h4>
        <p>负责统筹、安排卡车业务管理公司内部的培训工作（技术培训、销售培训、能力培训等），协调卡车内部讲师资源，负责卡车内部的技术培训工作，负责卡车公司服务版块人员技术支持工作；
        负责对接专用车、依维柯改装支持工作；红岩、陕汽、重汽应急服务。</p>
        <h4>1.5金融保险部</h4>
        <p>负责整合卡车管理公司整车销售及二手车金融资源，建立自有融资租赁系统；监督金融流程执行；整合保险资源，对接各个整车及售后服务版块。</p>
        <h4>1.6销售支持部</h4>
        <p>整合管理公司各公司、部门销售支持人员，成立销售支持群，协助管理委员会制定合同标准模板，制定销售工作的标准流程，监督销售人员日常的执行情况，汇总合同及收付款情况，同时与财务部对接；</p>
        <p>各部门销售支持人员负责管理所有车辆钥匙，单证；按照流程，未收到款项前不得将车辆钥匙及单证交给任何人，此项直接向管理公司总经理负责；
        按照合同模板规定的项目，未有项目更改的合同由各单位销售支持人员向销售支持部提交审核,通过后由所属单位对应授权人员签字盖章； 
        合同模板有更改的项目必须由销售支持部提交管理公司总经理审核后，交由财务部审核后方可签字盖章。（合同模板稍后会以通知形式下发）。</p>
        <h4 name="0-5-1-0-1-1" className="point" id="0-5-1-0-1-1">2. 卡车业务管理公司下属各事业部及公司</h4>
        <h4>2.1 斯堪尼亚北京公司</h4>
        <p>负责辖区内（北京）的斯堪尼亚牵引车销售及售后服务工作，依维柯产品的售后服务。同时负责对接大客户进口车的销售。需符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；</p>
        <p><strong>内蒙古服务站，</strong>向斯堪尼亚北京公司工作汇报。</p>
        <h4>2.2 斯堪尼亚天津服务事业部</h4>
        <p>负责辖区内（天津）的斯堪尼亚售后服务工作。行政安全受天津欧豪富港汽车贸易有限公司总经理领导，进口车业务受进口卡车事业部监管；需符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；</p>
        <h4>2.3 斯堪尼亚石家庄</h4>
        <p>负责辖区内（河北地区）的国产车、配件及斯堪尼亚售后服务工作，取得斯堪尼亚销售授权前，从斯堪尼亚北京获取销售资源；需符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；</p>
        <h4>2.4 斯堪尼亚沈阳</h4>
        <p>负责区域内（黑吉辽地区）的整车销售及售后服务工作，哈尔滨服务站归沈阳管理；须符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；
黑龙江服务站，向斯堪尼亚沈阳工作汇报。</p>
        <p><strong>黑龙江服务站，</strong>向斯堪尼亚沈阳工作汇报。</p>
        <h4>2.5 新疆公司</h4>
        <p>负责区域内的整车销售及售后服务工作；需符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；</p>
        <h4>2.6 依维柯整车事业部</h4>
        <p>负责与依维柯厂家对接，负责依维柯整车销售；依维柯服务直接向斯堪尼亚北京对接；需符合公司的管理规定，满足依维柯的厂家对经销商的要求；</p>
        <h4>2.7 专用底盘事业部</h4>
        <p>负责斯堪尼亚消防底盘、特种底盘的销售工作；需符合公司的管理规定，满足斯堪尼亚的厂家对经销商的要求；</p>
        <h4>2.8 北京红岩品牌部</h4>
        <p>负责红岩北京区域的销售工作，需符合公司的管理规定，满足厂家对经销商的要求；</p>
        <h4>2.9 天津红岩品牌部</h4>
        <p>负责天津区国产卡车的整车销售及售后服务工作；负责天津陕汽中心库，需符合公司的管理规定，满足厂家对经销商的要求；</p>
        <h4>2.10 陕汽品牌部</h4>
        <p>负责陕汽品牌的整车销售工作，需符合公司的管理规定，满足厂家对经销商的要求；相应品牌延庆基地形象店的管理工作；</p>
        <h4>2.11 重汽品牌部</h4>
        <p>负责重汽品牌的整车销售工作，需符合公司的管理规定，满足厂家对经销商的要求；相应品牌延庆基地形象店的管理工作；</p>

        <h3 name="0-5-1-0-2" className="point" id="0-5-1-0-2"> 卡车业务管理公司通用管理规定</h3>
        <h4>1. 厂家政策解读</h4>
        <p>由管理公司本部统一协调对应品牌独立核算单位的销售及服务负责人，共同解读相关厂家政策，要求相关负责人至少熟读5遍相关政策，并制定相应营销计划及服务方案；</p>
        <h4>2. 价格政策</h4>
        <p>各品牌单位年初汇总各厂家价格政策，报备给管理公司总经理；由管理公司本部统一管控价格体系；作为管理公司月会中一项议题，讨论未来一个月的持续价格；</p>
        <h4>3. 业务费用管理</h4>
        <p>3.1 卡车管理公司业务费用需提前报备给管理公司总经理，不接受事情发生后补报的；</p>
        <p>3.2 销售人员提起费用申请（签字），经部门负责人审批（签字），所属事业部负责人审批（签字）、管理公司总经理批准（签字）；适用整车销售/售后服务。</p>
        <h4>4. 业务费用管理</h4>
        <p>4.1 依照集团公司月会、周会、晨夕会管理细则执行。会议视频和纪要均由统计部处存档。</p>
        <p>4.2 为保证月会正常召开，要求各三级独立核算单元负责人及以上人员（含管理公司副总及各单位负责人）月度总结每月25日22:00前上交管理公司总经理，各三级独立核算单元负责人以下人员月度总结每月25日22:00前上交直管负责人、三级独立核算单元负责人、分管副总。</p>
        <p><strong>积分：</strong>未执行此制度责任人，每次-500分。</p>
        <p>管理公司月会原则上参会人员不得缺席，否则每次考核-800分。</p>
        <h4>5. 工资提报</h4>
        <p>各工资编制责任人于集团人力资源部每月下发基础工资表后（不含12月工资）第3个工作日17:30前，提交卡车业务管理公司总经理。
积分：未按时提交工资表，每次记录责任人-500分，并自考核生效日起，每延误1天追加考核-200分，上不封顶。</p>
        <h4>6. 考勤</h4>
        <p>6.1 各事业部、公司必须保证员工每周休息一天。</p>
        <p>6.2 如有加班人员，必须保证轮休足够时间才可上岗工作（加班至凌晨2点，第二天强制休息半天，并按正常出勤），并适用于外出服务人员。外出抢修人员必须住宿。</p>
        <p>6.3 管理公司全体人员使用钉钉打卡；销售人员当天提交日报，日报要求：个人定位、客户门头照片、拜访内容等，日报抄送直管负责人、业务分管领导。</p>
        <p>积分：未执行规定的相关人员记录-200分。</p>
        <h4>7. 营销风险管控</h4>
        <p>7.1 由卡车管理公司销售支持部整合管理公司下属单位销售支持人员，成立销售支持群，协助管理委员会制定合同标准模板，制定销售工作的标准流程，监督销售人员日常的执行情况，汇总合同及收付款情况，同时与财务部对接；</p>
        <p>7.2 销售支持人员负责合同台账编制，合同执行情况监管。</p>
        <p>7.3 各部门销售支持人员负责管理所有车辆钥匙，单证；按照流程，未收到款项前不得将车辆钥匙及单证交给任何人，此项直接向管理公司总经理负责；</p>
        <p>7.4 按照合同模板规定的项目，未有项目更改的合同由各单位销售支持人员向销售支持部提交审核，通过后由所属单位对应授权人员签字盖章；</p>
        <p>7.5 合同模板有更改的项目，必须由销售支持部提交管理公司总经理审核，通过后交由财务部审核后方可签字盖章。</p>
        <p>7.6 整车销售人员按照部门总监批准的价格，交货期，付款方式与客户确定合同条款；公司不承认销售人员与客户的任何口头协定，一切以合同为准。</p>
        <h4>8. 合同签署权限管理</h4>
        <p>8.1 采购、销售合同（北京）：由卡车业务管理公司总经理签署。</p>
        <p>8.2 采购、销售合同（外地公司）：由外地公司负责人签署，签署前由其销售支持人员提报卡车业务管理公司总经理批准后，方可签署。</p>
        <p>8.3 合同监管：由卡车业务管理公司协同各独立核算单元共同出具销售合同模板并经财务部审核通过后作为标准合同模板（外贸与内贸）。</p>
        <p>8.4 使用标准模板时，销售支持根据销售与客户协商的技术规格、交货期及付款方式填写销售合同，向财务部申请盖章、打印并交于销售代表与客户完成签约。</p>
        <p>8.5 使用非标准模板时，由独立单元的销售支持将修改后的销售合同交卡车管理公司销售支持审核修改，并让卡车业务管理公司销售支持交于财务部，审核通过后才可打印盖章。</p>
        <p>8.6 各分公司签署的各项合同，合同原件统一交由管理公司销售支持部，由销售支持部统一交付集团财务部，部门、管理公司留存复印件（扫描件）。</p>
        <p>各公司销售支持负责合同跟踪汇总表（格式由管理公司统一下发模板）。</p>
        <p>积分：如有违反2.7,2.8 项下规定但未造成损失的的考核相关人员-500分；</p>
        <p>如造成损失的则追加损失金额50%的，销售人员及公司经理按照3:7的比例承担损失；如因销售支持人员严格按照标准执行，避免损失的，销售支持人员+200分。</p>
        <p>8.7 关于大客户业务由集团客户部梳理组织，并分配到对应的各核算单元，按照相应的标准在规定时间内完成工作，由卡车业务管理公司公关部负责人与各核算单位日常对接。
积分：违反规定拒不执行的考核相应责任人-500分。</p>
        <h4>9. 员工行为规范</h4>
        <p>9.1 不得与客户签订阴阳合同，虚报利润，欺瞒公司；</p>
        <p>9.2 不得配合客户违规套取金融款项；</p>
        <p>9.3 不得欺骗并收取客户不存在的费用，如代收挂靠费，保险费等；</p>
        <p>9.4 所有业务收款须由客户直接汇款至公司指定账户，</p>
        <p>或公司财务指定的微信收款码上，业务人员不得私自收取客户钱款（如：现金、微信、支付宝、个人银行卡）；</p>
        <h4>9.5 未满足交付条件违规交车的；</h4>
        <p>9.6 与客户发生利益往来、参与客户经营、投资等；</p>
        <p>9.7 生效时间为2020年5月27日。</p>
        <p>以上行为视为重大违规违纪事件，如卡车业务管理公司员工出现以上行为者，将按照重大违规违纪对操作者予以解除劳动关系且不予任何补偿，
            并保留对相应操作人追偿的权利，同时将依法追究操作人法律责任。对所属部门总监按重大管理缺失考核。最终解释权归云豪集团卡车业务管理公司所有。</p>
        <h3>10.卡车业务管理公司整车金融业务管理细则</h3>
        <p>10.1合作金融公司：卡车公司金融保险部与金融公司正式合作前，签署框架合作协议，约定承担责任，放款条件，放款时间，放款路径后，即为合作金融公司；</p>
        <p>10.2卡车公司各销售公司须使用合作金融公司，不得自行选择非合作金融公司；</p>
        <p>10.3特殊情况下各销售公司可根据客户实际需求向金融保险部推荐其他金融公司，但仍需正式成为合作金融公司方能开展合作；</p>
        <p>10.4 金融公司需求资料由金融保险部协调财务予以提交。</p>
        <p>10.5 金融合同确定</p>
        <p>10.5.1 整车销售人员确定客户销售信息，向客户收取定金（1-5万元），根据客户认定标准（按车型、客户类型分类）收集客户真实金融所需材料；</p>
        <p>10.5.2 卡车公司金融保险部对客户资料审核通过后，配合整车销售向客户提供金融方案；</p>
        <p>10.5.3 由金融保险部对整车销售提报客户资料审核后向金融公司提供到位；</p>
        <p>10.5.4 整车销售配合金融公司完成实地考察；</p>
        <p>10.5.5 销售公司收到金融公司审批通过意见（书面文件或邮件通知）后，及时与合作金融公司签订金融合同。</p>
        <p>10.6 金融合同执行</p>
        <p>10.6.1 销售公司向厂家下达整车采购订单；</p>
        <p>10.6.2 整车销售通知客户交首付，并向金融公司出具收款确认书；</p>
        <p>10.6.3 整车销售配合交车（车辆、合格证、发票、单据并与客户签署交车单，严格按照合作金融公司放款要求，注意风险把控），并协助办理牌照和保险（符合合作金融公司保险要求）；</p>
        <p>10.6.4 递交金融回款材料并督促金融公司完成回款；</p>
        <p>10.6.5 约定时间未回款的，由各整车销售公司提报至金融保险部，随后金融保险部介入督促回款，记录差异并上报卡车公司，制定改进方案。</p>
        <p>10.7 金融合同档案管理</p>
        <p>10.7.1 金融合同原件存档至金融保险部；</p>
        <p>10.7.2 销售公司留存金融合同复印件或电子文档；</p>
        <p>10.7.3 由金融保险部负责根据集团财务要求提供金融合同资料。</p>
        <p>10.7.4（由金融保险部筛选推荐），以提高服务优势。</p>
        <h4>10.8 库存融资或特殊政策申请</h4>
        <p>10.8.1 库存融资由销售公司结合实际金融需求，经金融保险部审核、集团财务审批后与金融公司签订金融合同；</p>
        <p>8.2 国产车销售由销售公司根据实际情况提交特殊政策申请。</p>
        <h4>10.9 金融交车流程</h4>
        <p>10.9.1 收到客户定金（1-5万）；</p>
        <p>10.9.2 经合作金融公司审批通过并签订金融合同（或合作金融公司邮件审批通过）；</p>
        <p>10.9.3 向厂家下达整车采购订单；</p>
        <p>10.9.4 收到金融合同首付款；</p>
        <p>10.9.5 交车（车辆、发票、单证并与客户签署交车单）；</p>
        <p>10.9.6 办理牌照及保险（符合合作金融公司保险要求）；</p>
        <p>10.9.7 递交金融回款材料；</p>
        <p>10.9.8 完成回款；</p>
        <p>10.9.9 金融合同存档至金融保险部;</p>
        <p>10.9.10 约定时间未回款的，由各整车销售公司提报至金融保险部，随后金融保险部介入督促回款，记录差异并上报卡车公司，制定改进方案；</p>
        <p>10.9.11 客户全款购车的，必须收齐全款后，方可申请开票，交车。</p>
        <h4>10.10 保险业务</h4>
        <p>合作金融公司未指定保险公司情况下，优先推荐卡车公司现有合作保险渠道</p>
        <h4>11 国产车交接车辆流程及执行标准</h4>
        <h4>11.1 目的：</h4>
        <p>为了规范和加强卡车业务管理公司国产车交接车辆制度，严格管控车辆交接工作流程，更好的提升工作效率，特制定此标准。</p>
        <h4>11.2 流程规范及要求：</h4>
        <p>1、所售车辆均需有购销合同</p>
        <p>2、接车、交车需有单据（接车单、交车单）</p>
        <p>3、接车、交车需有照片（客户、销售、服务人员三方合影）</p>
        <p>4、接车、交车单由接车、交车当日提交至各品牌对应销售支持处，由销售支持负责存档；</p>
        <p>5、车辆交付完成（客户上牌完成）客户交车信息由销售人员提报至各品牌对应销售支持处，再由销售支持提报至云豪车服刘永强邮箱（邮箱：yongqiang_bjqichi@126.com）</p>
        <p>注明：按要求填写至客户交车信息表内</p>
        <h4>11.3交车检查流程：</h4>
        <p>商品车辆抵达预定地点（公司内或客户指定地址），由验车人员（公司内由销售支持岗位负责，非公司内由销售人员负责）及车辆驾驶员共同对车辆进行检查。检查项目如下：</p>
        <p>1、基本信息：依照车辆一致性证书及车辆配置表，核对车辆底盘号、发动机号、车身颜色是否一致。（根据各品牌厂家单据）</p>
        <p>2、车辆外观：环车检查车辆是否有划痕、漆面不均、碰撞伤、灯罩是否完好有无破损及裂纹、轮胎型号是否一致、钢圈是否有锈迹。</p>
        <p>3、车辆内饰：检查车门内饰板、装饰板、操控台、天窗等是否有划痕、断裂、是否完好。</p>
        <p>4、车辆灯光：检查前近光灯、远光灯、转向灯、前后雾灯、倒车灯、倒车蜂鸣器、刹车灯、示宽灯等是否可以正常开启和关闭。</p>
        <p>5、使用功能：检查车辆玻璃升降功能、电动调节后视镜（如有）、车辆音响、室内灯光控制、座椅调节功能、仪表板是否正常显示。</p>
        <p>6、随车附件：因车辆配置不用，按照各品牌厂家提供的车辆配置表进行逐项检查，车辆检查完毕完成《车辆交接单》（国产车分别根据各品牌厂家要求填写）并签字确认，对于车辆破损及损坏部位进行拍照，最后由销售支持汇总车辆存在的问题及破损照片以邮件的形式上报各品牌厂家跟进并予以索赔。</p>
        <p><strong>注：接车检查单详见附件（表格一）</strong></p>
        <div><strong style={{color:'#6699FF'}}>11.4附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure627' title="《交车流程及执行标准》" onClick={(value)=>this.showDrawer(value)}>《交车流程及执行标准》</a></div>
        <br></br>
        <p><strong>注：交车检查单详见附件（表格二）</strong></p>
        <div><strong style={{color:'#6699FF'}}>附件（表格一）：</strong><a href="javascript:void(0);" type="primary" id='Enclosure628' title="《国产车接车检查单》" onClick={(value)=>this.showDrawer(value)}>《国产车接车检查单》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件（表格二）：</strong><a href="javascript:void(0);" type="primary" id='Enclosure629' title="《国产车交车检查单》" onClick={(value)=>this.showDrawer(value)}>《国产车交车检查单》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure630' title="《国产车信息汇总表（交车信息表、库存表、应收账款）》" onClick={(value)=>this.showDrawer(value)}>《国产车信息汇总表（交车信息表、库存表、应收账款）》</a></div>
    
        <h4>12 集团公司改装业务及厂家支持业务</h4>
        <p>集团公司改装业务及厂家支持业务由售后服务部门（施工方）无条件承接，需求方与施工方关于施工时间、质量标准和内部结算价商定后上报管理公司审核通过，并由施工方向需求方开具内部结算单，并报财务部进行账务划转，（记：施工方的其它收入；记：需求方的其它支出）施工过程中产生损失由施工方承担。</p>
        <h4>13 其他即时管理事项</h4>
        <p>管理公司根据业务管理要求下达相应即时通知，并明确具体上报时间要求的，凡未及时上报的每次考核责任人-500分，并自考核生效日起，每延误一天追加考核-200分，上不封顶。
管理公司本部下达的要求，未按时完成或无故不执行的，考核相应责任人每次-500分。</p>

        <h3 name="0-5-1-0-3" className="point" id="0-5-1-0-3"> 卡车业务管理公司销售绩效细则</h3>
        <h4>1. 定义</h4>
        <p><strong>1.1 完成销售：</strong>与客户签订销售合同，收讫全部合同款项，交付最终用户。</p>
        <p><strong>1.2 销售毛利：</strong>销售毛利=销售价格-采购价格-赠送服务-上牌费用（如有）-转介绍人员奖励-金融利息-增值税</p>
        <p><strong>1.3 见习销售：：</strong>入职6个月内的销售岗员工；</p>
        <p><strong>1.4 销售员：：</strong>入职4个月以上的见习销售且完成销售环节中金融环节、上牌环节、合同签署环节各3单，通过“初级技师”考核。</p>
        <p><strong>1.5 销售经理：</strong>销售公司负责人即直接向部门总监汇报工作，承担整个部门销量目标任务。通过“高级技师”考核。</p>
        <p><strong>1.6 销量：</strong>即完成销售的数量；</p>
        <h4>2 销售绩效发放节点：</h4>
        <p><strong>专用车及依维柯销售人员：</strong>与客户签订合同，收讫合同款项（不含质保金）次月发放；</p>
        <p><strong>进口牵引车及国产车：</strong>2.2与客户签订合同，收讫全部合同款项（包含金融尾款、服务包（如有）等全部款项）且交付最终用户，牌照办理完成，且无质量纠纷的，次月发放；</p>
        <p><strong>销售公司负责人（含总监级）：</strong>当年12月31日前，完成全年销售目标，与客户签订销售合同，收讫全部合同款项，车辆交付客户后，次年发放。</p>
        <p><strong>当年销量中，只收到客户预付款（30%预付款），</strong>签订销售合同，签订采购合同，厂家下单生产，当年销量按照50%计入销量。</p>
        <p><strong>采用信用证的，</strong>需完成信用证议付，计入当年销量，否则计入下一年销量。</p>
        <p><strong>佣金类，</strong>我司收取佣金类的销售合同，佣金到账我司后，计入当年销量，否则计入下一年销量。</p>
        <p>所属部门质保金由销售公司负责人负责收讫。</p>
        <h4>1.4.3 整车销售人员分配模式</h4>
        <p>带有整车销售属性的部门须按照各自销售人员招聘总目标划定相应区域（如部门现有1名销售，年底或未来团队人数为5人，含销售经理，即将所属区域划定为5个区域。现有的1名销售优先选择主负责区域，兼其它区域销售职能，即副销售区域，待新人入职后分配副销售区域）</p>
        <h4>3.1 斯堪尼亚（北京、天津、石家庄、沈阳）整车销售人员</h4>
        <p>3.1.1 销售员独立完成销售；每台车按照销售毛利分红20%；</p>
        <p>3.1.2 见习销售由销售经理协助完成销售，每台车按照销售毛利10%分红，销售经理每台车按照销售毛利10%提成。</p>
        <p>3.1.3 销售经理主负责区域直接销售每台车按照销售毛利20%分红。</p>
        <p>3.1.4 销售经理达成当年部门总体<strong>整车销量目标，销售部门团队建设目标，日常销售报告及会议（岗位责任书中明确），</strong>按照全部销量每台车销售毛利10%分红作为其团队管理绩效，各项目标完成率80%此项有效。</p>
        <p>3.1.5 集团大客户，销售员跟单绩效提成300元/台（负责交车及上牌）；销量按照25%计入部门销量，销售毛利不做提成；</p>
        <h4>3.2 国产车版块</h4>
        <p>3.2.1 国产品牌独立完成销售</p>
        <p>3.2.2 红岩品牌独立完成销售；按照每台车销售毛利20%分红（保底1000元/台）；</p>
        <p>3.2.3 陕汽品牌独立完成销售；按照每台车销售毛利20%分红（保底1000元/台）；</p>
        <p>3.2.4 重汽品牌独立完成销售；按照每台车销售毛利20%分红（保底1000元/台）；</p>
        <p>3.2.5 见习销售，由销售经理协助完成销售，每台车按照10%毛利分红，销售经理每台车按照10%毛利分红；</p>
        <p>3.2.6 销售经理（包括未成建制的部门负责人）达成当年部门总体<strong>整车销量目标，销售部门团队建设目标，日常销售报告及会议（岗位责任书中明确），</strong>年底发放，所属全部销量按照每台车300元作为其团队管理绩效，各项目标完成率80%此项有效。</p>
        <p>3.2.7 集团大客户，跟单绩效2000元/单，销量按照25%计入所属部门销量，销售毛利不做提成。
销售人员自己销售的车辆需协调其他销售协助上牌，给予其他销售人员200元/台，费用算到车辆销售部门</p>
        <h4>3.3<strong>非销售岗位介绍成交（包括客户转介绍的）</strong>销售人员按照3.1和3.2标准执行；</h4>
        <p><strong>职责划分：由销售人员签订合同，金融及上牌等后续工作由销售人员跟进完成</strong></p>
        <h4>3.4 专用车及依维柯</h4>
        <p>3.4.1 销售员，独立完成销售绩效为3000元/台；</p>
        <p>    有二级代理绩效1500元/台；</p>
        <p>    跟单（销售经理协助完成签单的）销售绩效为1500元/台。</p>
        <p>3.4.2 销售经理，主负责区域直接销售，提成3000元/台；</p>
        <p>3.4.3 销售经理达成当年部门总体整车销量目标，<strong>销售部门团队建设目标，日常销售报告及会议（岗位责任书中明确）</strong>，按照总销量每台车1000元作为其团队管理绩效，年底发放，各项目标完成率80%此项有效</p>
        <h4>4. 集团非销售岗位人员绩效办法</h4>
        <p>4.1<strong>适用对象：</strong>云豪集团所有人员</p>
        <p>4.2<strong>有效性：</strong>客户信息应为直接购车的新客户，即未从我司购买过车辆的，中间商及介绍成交后再次购车的客户不在此范围内（作为信息介绍鼓励发现开拓新客户，已购车客户应由专业的销售人员持续跟进，从而保证客户的忠诚度，销售人员有相应的客户满意度考核）</p>
        <p>4.3<strong>有效信息积分奖励：</strong>提供有效购买信息的，100分/次（非集团公司代理品牌，并与销售系统内现有客户重合的算无效信息）</p>
        <p>4.4<strong>实现销售：</strong>提供有效信息并协助销售人员完成销售的， 非销售岗位获得毛利10%分红，由销售岗位人员与客户签订整车销售合同并完成交车回获得毛利10%分红</p>
        <p>4.5 禁止销售人员及非销售岗位人员相互串通，编造信息，欺骗公司，如发现此类情况将通知财务部扣除相应奖励及分红并移送集团纪律检查委员会查办</p>
        <p>4.6 考虑到销售利润为公司商业机密，不进行公示，<strong>最终销售毛利以财务部核算为准</strong></p>
        <p>4.7<strong>4.1-4.6项“集团非销售岗位人员绩效办法”例试行一年</strong>，最终解释权为卡车业务管理公司</p>
        <h4>5. 客户转介绍业务费用</h4>
        <p>客户转介绍，签订销售合同并完成收款的，视利润情况，一单一议，上限2000元/台或等值的维修代金券、油卡</p>
        <h4>6. 车险（商业险）绩效提成办法</h4>
        <p>6.1 2020年试行保险返点取消现金返点形式，将采用维修代金券形式（具体返还政策以每月出具的保险政策为准）返还用户</p>
        <p>（例如：正常现金返点为15%，维修代金券为保费20%；20%保险代金券实际产生其中15%由保险部承担，5%为各品牌相应维修单位承担）</p>
        <p>注：</p>
        <p>（1）使用代金券不得以其它优惠活动同时使用，执行零件及工时的正常价格</p>
        <p>（2）如客户产生退保的，也要退回优惠钱数</p>
        <p> 6.2 集团公司非保险岗位推销商业保险完成销售的，相应人员奖励200分</p>
        <h4>7. 有效二手车信息积分奖励规则</h4>
        <p>7.1 适用对象：卡车业务管理公司所有员工（1-9级）</p>
        <p>7.2 二手商用车信息要求：</p>
        <p>7.2.1 商用车；</p>
        <p>7.2.2 货车（轻、中、重卡）</p>
        <p>7.2.3 中巴（非营运），汽油版，4-5年内车辆</p>
        <p>7.2.4 一个月内随时可以交易的车辆</p>
        <p>7.3 信息构成：</p>
        <p>7.3.1 何地牌照</p>
        <p>7.3.2 上牌日期</p>
        <p>7.3.3 强制报废日期</p>
        <p>7.3.4 品牌，基本配置，发动机马力，公里数</p>
        <p>7.3.5 排放（货车以2014年之前国三排放为主）</p>
        <p>7.3.6 车辆外部照片：左前45°，车侧，正后方三张照片;车辆内部照片：仪表盘点亮照片（显示公里数），驾驶室内照片，两张照片</p>
        <p>7.3.7 意向销售价格</p>
        <p>7.4 有效二手车源信息定义：云豪集团员工所提交信息集团公司收购成功视为有效信息（由专人负责的网络或APP车源信息不在此范围内）</p>
        <p>7.5 有效二手车源信息奖励200积分/台</p>
        <p>7.6 整车销售人员完成新车销售并完成置换的，奖励200积分/台</p>
        <p>7.7 信息提报对接人：卡车业务管理公司，销售支持部</p>
        <p>以上有效二手车信息积分奖励规则为试行规则II版，后续规则发布后此版本自行失效，以上规则最终解释权为卡车业务管理公司</p>
        <h4>8. 8.卡车业务管理公司全员销售（专用车）细则（试行版）</h4>
        <h4>8.1、名词定义：</h4>
        <p>8.1.1、品牌销售：指完成销售车辆对应的品牌所属整车销售人员（含销售经理）；</p>
        <p>8.1.2、信息提供人：指其他品牌整车销售人员（含销售经理）；</p>
        <p>8.1.3、完成销售（见员工手册）后，按照以下标准执行。</p>
        <h4>8.2、提成标准：</h4>
        <p>8.2.1、品牌销售：3000元/台；</p>
        <p>8.2.2、信息提供人：3000元/台。</p>
        <h4>8.3、执行标准：</h4>
        <p>8.3.1、品牌销售及信息提供人在销售前不得对客户做出任何承诺，须向各自总监提前报备，反之按照重大违规事件处理；</p>
        <p>8.3.2、信息提供人将有购买其他品牌车辆意向的客户信息报备给总监，由信息提供人总监向对方总监确认；</p>
        <p>8.3.3、双方总监各自分配对应工作；</p>
        <p>8.3.4、完成销量计入本品牌（例如：斯堪尼亚部门销售依维柯车辆，销量计入依维柯品牌部）；</p>
        <p>8.3.5、品牌销售及信息提供人绩效发放，收到30%预付款发放一半绩效，收到全款发放剩余绩效。</p>
        <p>注：此版本为试行版，由卡车业务管理公司负责修订，新版本生效后此版本自动失效，最终解释权归卡车业务管理公司所有。</p>

        <h4>9. 销售管理表格范本</h4>
            <div><strong style={{color:'#6699FF'}}>9.1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure67' title="《报价函》" onClick={(value)=>this.showDrawer(value)}>《报价函》</a></div>
            <div><strong style={{color:'#6699FF'}}>9.2：</strong><a href="javascript:void(0);" type="primary" id='Enclosure68' title="《客户拜访表——牵引及服务销售》" onClick={(value)=>this.showDrawer(value)}>《客户拜访表——牵引及服务销售》</a></div>
            <div><strong style={{color:'#6699FF'}}>9.3：</strong><a href="javascript:void(0);" type="primary" id='Enclosure69' title="《客户拜访表——专用车》" onClick={(value)=>this.showDrawer(value)}>《客户拜访表——专用车》</a></div>
            <div><strong style={{color:'#6699FF'}}>9.4：</strong><a href="javascript:void(0);" type="primary" id='Enclosure610' title="《销售进程看板》" onClick={(value)=>this.showDrawer(value)}>《销售进程看板》</a></div>
            <div><strong style={{color:'#6699FF'}}>9.5：</strong><a href="javascript:void(0);" type="primary" id='Enclosure611' title="《成交客户信息交接单》" onClick={(value)=>this.showDrawer(value)}>《成交客户信息交接单》</a></div>

        <h3 name="0-5-1-0-4" className="point" id="0-5-1-0-4"> 卡车业务管理公司售后服务收入细则</h3>
        <h4>1. 生产车间绩效统计方式</h4>
        <p>总绩效构成=正常工时+加班工时+出车里程补助+正常使用零件提成+服务零件销售提成+其它</p>
        <h4>2. 服务绩效</h4>
        <img src={fuwujixiao} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/><br/>
        <p><strong>销售岗位及办公室人员销售工时及配件同样按照上述绩效进行分配。</strong></p>
        <h4>3. 维修事故考核标准</h4>
        <img src={weixiushigukaohebiaozhun} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/><br/>
        <h3 name="0-5-1-0-5" className="point" id="0-5-1-0-5"> 卡车业务管理公司差旅积分细则</h3>
        <br/>
        <p>根据集团员工手册内动态积分的设定内容要求，对卡车业务管理公司差旅积分细化如下：</p>
        <h4>1. 享受差旅积分条件</h4>
        <img src={xiangshouchailvjifentiaojian} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/><br/>
        <h4>2. 差旅补助积分标准</h4>
        <img src={chailvbuzhujifen} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/><br/>

        <h3 name="0-5-1-1" className="point" id="0-5-1-1">2、客车业务管理公司内部管控流程及标准</h3>
        <h4 name="0-5-1-1-0" className="point" id="0-5-1-1-0">第一节2020年客车公司组织机构图及人事安排</h4>
        <h3>一、2021年客车公司组织机构图</h3>
        <img src={keche11} alt="" style={{width  : '850px',display: 'block',margin : '0 auto'}}/> 
        <h3>二、客车业务管理公司支持机构人事安排 ：</h3>
        <p><strong>1、总经理：</strong>张少先，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，主管锂电池再循环事业部、綦齿事业部，监管威伯科事业部。 
        </p>
        <p><strong>2、副总经理：</strong>王云伟，主管威伯科事业部，服从总经理的工作安排，对上级领导汇报工作。负责集团公司二手车源采购业务。 </p>
        <p>兼任再循环产业管理公司副总经理，负责二手车源采购业务。</p>
        <p><strong>3、副总经理：</strong>霍涛，负责客车公司特定项目的投标工作、技术培训工作；主管锂电池事业部，服从上级领导的工作安排，对总经理汇报工作。</p>
        <p><strong>4、行政部负责人：</strong>史玉柳（科级），各部门人员招聘、职业规划、职业发展、合同文档管理，跟进员工培训计划，对接集团人力资源部和办公室的工作。
        管理监督客车业务管理公司所属各事业部统计人员工作，监管各事业部经营数据的准确性，应收账款按照公司规定执行等，服从上级领导工作安排，向集团公司财务中心及总经理汇报。 </p>

        <h3>三、客车业务管理公司营销机构人事安排  ：</h3>
        <h4>1、锂电池再循环事业部：</h4>
        <p><strong>负责人：</strong>霍涛（副总经理级），全面负责该事业部的人、财、物、产、供、销，为该事业部第一责权人，事业部为独立核算单位。对总经理汇报工作，服从上级领导工作安排。</p>
       
        <p><strong>副总监：</strong>齐胜利，主管技术开发科、生产制造科（开发、生产、应用、工艺、质量），对总经理汇报工作，服从上级领导的工作安排。</p>
        
        <p><strong>1.1 销售支持科 负责人：</strong>齐胜利（兼） </p>
        <p><strong>1.2 采购科 科长：</strong>李鹏 对事业部负责人汇报工作，服从上级领导工作安排。</p>
        <p><strong>1.3 技术开发科 负责人：</strong>齐胜利（兼）</p>
        <p><strong>1.4 销售服务公司 负责人：</strong>石浩 对事业部负责人汇报工作，服从上级领导工作安排。</p>
        <p><strong>1.5 生产制造科 负责人：</strong>张帅 对主管副总监汇报工作，服从上级领导工作安排。</p>
    
        <p>2、綦齿事业部：</p>
        <p><strong>总监：</strong>吕建龙 （一级），全面负责该事业部的人、财、物、产、供、销，为该事业部第一责权人，事业部为独立核算单位。对总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>2.1 计划科 科长：</strong>刘永杰，负责计划科全面工作，对事业部总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>2.2 仓储物流科 科长：</strong>刘永杰（兼），负责仓储物流科全面工作。对事业部总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>2.3 车间管理科 科长：</strong>程丽丽，负责车间管理科全面工作。对总监汇报工作，服从上级领导工作安排。 </p>
        <p><strong>2.4 维修公司 负责人：</strong>张乐乐（科级），负责维修公司全面工作，对事业部总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>2.5 销售公司 负责人：</strong>吕建龙（兼），负责事业部所有配件业务的市场营销工作，对事业部总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>区域经理：</strong>王宪峰 （科级），负责二保修三车间（东直门）销售及服务工作，对销售公司负责人汇报工作，服从上级领导工作安排。 </p>
        <p><strong>区域经理：</strong>杨志 （科级），负责二保修二、四车间（大兴，延庆）销售及服务工作，对销售公司负责人汇报工作，服从上级领导工作安排。 </p>
        <p><strong>区域经理：</strong>胡浩（副科级），负责公交二保修一车间，兼保修间销售及服务工作，对销售公司负责人汇报工作，服从上级领导工作安排。 </p>

        <h4>3、威伯科事业部：</h4>
        <p><strong>总监：</strong>韩磊（一级），全面负责该事业部的人、财、物、产、供、销，为该事业部第一责权人，事业部为独立核算单位。对分管副总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>3.1 计划科 科长：</strong>马静，对总监汇报工作，服从总监的工作安排。</p>
        <p><strong>3.2 仓储物流科 科长：</strong>徐国强，主管仓储物流科全面工作，对事业部总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>3.3 销售科 科长：</strong>刘郡 ，负责各区域销售，对总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>3.4 威伯科北京公司 负责人：</strong>韩磊</p>
        <p><strong>3.5 威伯科天津项目 负责人：</strong>王珂（副总监级） 对管理公司分管副总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>3.6 威伯科石家庄项目 对接人：</strong>韩骥（兼）</p>
        <p><strong>3.7 威伯科配套项目 负责人：</strong>韩磊（兼） </p>

        <p><strong>4、天津客车事业部：</strong></p>
        <p><strong>总监：</strong>王珂（一级），全面负责该事业部的人、财、物、产、供、销，该事业部第一责权人，事业部为独立核算单位。对总经理汇报工作，对对应业务领域的相关负责人汇报工作，服从上级领导工作安排。
        </p>
        <p><strong>4.1 计划科 负责人：</strong>王珂（兼）</p>
        <p><strong>4.2 仓储物流科 负责人：</strong>王珂（兼）</p>
        <p><strong>4.3 维修公司 经理：</strong>裴俊鹏（科级），对总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>4.4 销售公司 经理：</strong>王珂（兼）</p>
        <h4 name="0-5-1-1-1" className="point" id="0-5-1-1-1">第二节 客车业务管理公司各科室职能及作业流程标准</h4>
        <h4>一、独立考核单位部室职能</h4>
        <h4>1.1 统计部 </h4>
        <p>负责客车管理公司行政工作，作为管理公司与集团公司行政对接人员，对接集团公司人力资源（校企合作人才）的接收工作。 </p>
        <p>纵向监管各事业部统计科，通过统计部职能对业务管理公司人、财、物、产、供、销经营方向提供有效数据支撑；</p>
        <p>整合管理公司各部室统计人员，成立统计工作组；对各部室日常出入库，晨会，周会，月会，工作标准的执行情况进行监督；未按照规定执行的总监考核积分100分，月度会议考核积分200分。 </p>
        <h4>1.2 网络营销部 </h4>
        <p>主管配件业务管理公司网络营销。 </p>
        <h4>1.3 技术标准部 </h4>
        <p>维修标准、投标标准等标准化。 </p>
        <h4>二、独立核算单位科室职能 </h4>
        <h4>2.1 销售科 </h4>
        <p>依据个人区域销售指标并结合业务单位（人员、车型、保有量、专项需求等）结构情况不同，制定相对应的销售解决方案。并按照区域市场开发流程收集市场信息（市场信息表）、客户信息；未按规定执行的负激励100分。  </p>

        <h4>2.2 配件科</h4>
        <p> 业务范围：负责事业部、分公司配件进、销、存的管理。 </p>
        <h4>采购流程</h4>
        <br/>
            <img src={caigouliucheng61} alt="" style={{width  : '600px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>配件入库流程</h4>
        <br/>
            <img src={rukuliucheng61} alt="" style={{width  : '600px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>库管</h4>
        <p>a、每日15时前到货清单清点核实配件（数量、配件图号、配件名称、型号、状态），确认无误清单签字后当日交统计，未按照规定执行确认数量、状态的考核积分100分。 </p>
        <p>b、根据配件到货数量20箱起分类并按库房货位上架码放整齐24小时内完成入库，少于20箱当日完成入库，未按照货位与货品规定执行的考核积分100分。 </p>
        <p>c、新产品货位区增加，当日建立货位卡并录入系统存档。未按照规定执行的考核积分100分。 </p>
        <h4>统计</h4>
        <p>a、根据到货清单系统入库，到货清单备注入库单号，未按照规定执行考核积分100分。 </p>
        <h4>配件出库流程 </h4>
        <br/>
            <img src={chukuliucheng61} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>库管</h4>
        <p>a、根据领料单、销售单需求清点核实配件（数量、配件图号、配件名称、型号、状态），配件出库必须有领料单、销售单，否则不予出库。无单出库者考核积分300分。</p>
        <p>b、要对配件进行打包，确保打包后的配件防水、防损、防蛀、防漏，并跟进物流状态。因包装出现配件损坏，考核积分300分。</p>
        <p>c、要给予客户将配件送搬上车，未按照规定执行考核积分50分。</p>
        <p>d、发货外地后要发运信息跟踪表并通知收货人，直至到达客户手中并记录接收人状态。未按照规定执行每单考核积分50分。</p>
        <p>e、出库后，库管员根据出库单认真填写卡片帐，做到帐实相符。未按照规定执行考核积分50分。</p>
        <br/>
            <img src={genzongbiao61} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>前台标准</h4>
        <p>a、配件图号、配件名称、数量开具销售单、出库单差异，造成退库考核积分50分。</p>
        <h4>配件退库 </h4>
        <p>a、销售员，对退件事件上报部门总监，经同意后方可办理退件手续。</p>
        <p>b、仓储计划员，按配件清单清点配件。</p>
        <p>c、库管检验再次核对配件数量及配件包装的完好程度。</p>
        <p>d、销售员，带客户到财务部办理退款手续。</p>
        <h4>库房货位精准率</h4>
        <p>货位精准性是提高备货效率、新人能够快速按货位备货，统计部每周两天抽查货位准确性，对于抽查无货位、混乱情况进行考核积分20分。</p>
        <p>出库频次高、出库量大的产品及时调整货位，便于出、入。</p>
        <h4>库房产品管理</h4>
        <p>先进先出，避免先进产品针对备货区域、储存区位置及备货时走动距离进行货位调整，应更靠近备货区方便取、入，根据历史数据留有足够空间；滞销产品远离备货区紧凑管理；每周提报货位优化明细，上报管理公司，未按规定执行总监负激励100分。</p>
        <h4>盘点管理流程</h4>
        <br/>
            <img src={pandianliucheng61} alt="" style={{width  : '600px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <h4>盘点管理标准</h4>
        <p>季度盘点财务部门应会同库管人员于季末应对各库房存货进行实地清查盘点。</p>
        <p>实地盘点结束后，由盘点人员在盘点表上签字，对于账实不符的情况，应查明原因，并编写盘点报告向总经理汇报。</p>
        <p>配件的原包装完好，不被污损。如因外界原因造成包装的损坏，则尽力寻找合适的包装，并做好标识，以避免配件受损或错用；</p>
        <p>油品（中桶限高5层），配件根据重量、大小、规格、进行码放整齐存放；</p>
        <p>所有较大物资放置托盘上存放不触地，防锈蚀；</p>
        <p>精密配件、燃气管及管类等重要管件要确保关键部位或整体防尘袋存放；</p>
        <h4>2.3 车间管理科</h4>
        <p>a、负责车间生产科维修标准监管执行落地； </p>
        <p>b、负责维修公司设备及工具管理；</p>
        <h4>2.4 统计科</h4>
        <p>业务范围：对事业部、分公司人、财、物、产、供、销经营方向提供有效数据支撑。横向对总监直接负责，纵向受统计部监管。 </p>
        <p>A、统计科负责收集各事业部、分公司数据报表（管理公司统一制定）；事业部、分公司每月27日上报，未按照规定执行的统计，负激励100分。 </p>
        <p>B、统计科负责事业部、分公司内的岗位人员需求信息收集并上报统计部，未按照规定执行负激励100分。</p>
        <p>C、对事业部、分公司日常出入库，晨会，夕会，周会，月会，工作标准的执行情况进行记录； </p>
        <p>D、负责事业部公交业务每月定期发票的申请，直至发票交付的跟踪，并对所开发票进行登记、扫描存档，未按规定执行的负激励100积分。</p>
        <p>E、对事业部考勤情况进行认真记录（正常出勤、迟到、早退、事假、病假、年假等）；</p>
        <p>F、配合事业部库房管理员库存报表的打印及库存的盘点；</p>
        <p>G、负责事业部各科室提报报销的核算、登记、上交；</p>
        <p>H、负责公交日常订单的制单，系统出库的核对、关单；</p>
        <p>I、负责事业部文件及合同的管理（打印、盖章、复印、存档），未按标准执行的负激励50积分；</p>
        <p>J、负责事业部车辆的出车里程登记（每周）、验车提醒（提前一个月提醒）、违章查询（每周）、油卡充值的提报；</p>
        <p>K、次月5日前完成上月误餐报销的整理，并交财务审核；</p>
        <p>L、外采供应商账目的核对，发票的登记及跟踪财务汇款；</p>
        <h4>2.5 车间生产科 </h4>
        <br/>
            <img src={chejianshengchai61} alt="" style={{width:'80%',minWidth  : '800px',display: 'block',margin:'0 auto'}}/> 
        <br/>
        <br/>
        <h2 name="0-5-1-2" className="point" id="0-5-1-2">3、云豪车服管理公司</h2>
        <h3 name="0-5-1-2-0" className="point" id="0-5-1-2-0">第一部分 云豪车服管理公司组织构架及人事安排</h3>
        <h3>一、组织构架</h3>
        <img src={yunhaochefu11} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <h3>二、云豪车服管理公司支持和监管机构管理层人事安排：</h3>
        <p><strong>1、总经理：</strong>刘永强，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，主抓全面工作，向董事长汇报工作。</p>
        <p><strong>2、副总经理：</strong>张琳，主管系统应用部全面工作，分管云豪车服APP全面工作，服从总经理的工作安排，对总经理汇报工作。</p>
        <p><strong>3、行政部 负责人：</strong>待定  负责管理公司人员招聘、事业规划、员工关怀，新员工培训，与集团人力资源部和云豪学院对接，团队活动策划组织，落实各事业部每周计划完成情况，量化数据向总经理汇报，对总理汇报工作；服从上级领导的工作安排。</p>
        <p><strong>4、技术部总监 ：</strong>徐文强（一级），负责管理公司的技术标准制定、维修指南编辑、技术培训、技术支持，技术资料库建设，对内与集团技术中心和云豪学院对接，对外与各品牌厂家服务工程师对接，对总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>技术部副总监 ：</strong>王鹏，负责配合技术部长落实技术标准制定、维修指南编辑、技术培训、技术支持，技术资料库建设，对技术部长汇报工作，在维修业务方面对大兴车服事业部维修销售公司负责人汇报工作，服从上级领导的工作安排。</p>
       
        <p><strong>5、系统应用部总监 ：</strong>张琳（兼）负责云豪车服APP产品设计、应用开发、线上业务推广、线上客户运营、线上招募创业班组、通过运营活动调动用户与创业班组的积极性。向主管副总经理汇报工作，服从上级领导的工作安排。</p> 
        <p><strong>系统应用部副总监 ：</strong>宁方伟 主管应用开发科，负责云豪车服APP产品设计，应用开发，对总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>系统应用部线上运营科科长 ：</strong>董宇凡 负责运营活动策划，运营活动投入产出比测算、用户画像制定，车服商城线上销售、客户及创业空间线上招募，对总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>系统应用部线上运营科副科长：</strong>李敏杰 对运营科科长汇报工作，服从上级领导的工作安排。</p>

        <h3>三、云豪车服营销机构人事安排：</h3>
        <h4>1、云豪车服APP </h4>
        <p><strong>总监：</strong>周超（二级），为该事业部人、财、物、产、供、销第一责权人，对集团公司各单位创业空间有监管职能。对分管副总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>副总监：</strong>梅腾飞，参与创业空间营销政策的制定，负责市场推广部全面工作，创业空间招募、云豪车服APP推广、云豪商城前期的筹备及营销，客户及用户信息的档案整理，对云豪车服APP总监汇报工作，服从上级领导的工作安排。</p>

        <h4>2、大兴车服事业部 </h4>
        <p><strong>总监：</strong>张东生（三级），为该事业部人、财、物、产、供、销第一责权人，对总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>副总监：</strong>兰树军，主管维修销售公司维修业务工作、创业空间及上线客户服务安排及协调，对事业部总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>维修销售公司销售业务负责人：</strong>张维（科级）对总监汇报工作，服从上级领导的工作安排。</p>

        <h4>3、延庆车服事业部</h4>
        <p><strong>总监：</strong>白亚平（一级），为该事业部人、财、物、产、供、销第一责权人，对总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>副总监：</strong>张松林，主管维修销售公司全面工作、创业空间及上线客户服务安排及协调，对事业部总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>维修销售公司销售业务负责人：</strong>周永超（科级）对主管副总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>副总监：</strong>王云雷，负责车险业务公司的全面工作，对总监汇报工作，服从上级领导的工作安排。</p>

        <br/>
        <h3 name="0-5-1-2-1" className="point" id="0-5-1-2-1">第二部分 云豪车服管理公司各部室职能及各岗位职责</h3>
        <h4>一、云豪车服管理公司各部室职能</h4>
        <p>1、行政部：负责云豪车服管理公司岗位需求招聘，对接集团公司人力资源部开展人员招聘工作，落实职级晋升标准的制定和实施，并对人员制定职业发展规划。</p>
        <p>2、技术标准部：负责云豪车服管理公司技术培训及标准制定和实施落地，对接集团技术中心和云豪学院开展工作。</p>
        <p>3、网络营销部：负责“云豪车服”“创业空间”网络宣传，对接电商中心跟进落实云创APP和ERP管理系统上线使用。</p>
        <p>4、统计科：负责协调部门日常服务结算，出入库单据整理，晨会，夕会，周会，月会，工作标准的执行情况进行日常统计汇总，
            会议要求：各项例会依照集团公司月会周会晨夕会管理细则，所有统计人员向总监汇总当天会议纪要，标准执行情况；其它会议项目由各公司、部门自行添加标准，随后会以通知形式下发；</p>
        <p>5、车间物业管理科：负责维修公司维修标准监管执行落地及维修设备和工具的管理，输出管理报表。</p>
        <p>6、服务科：</p>
        <p>6.1负责客户接待、上下游客户链接，客户信息收集、整理、客户回访，同时负责客户投诉、抱怨协调处理。</p>
        <p>6.2负责各品牌三包索赔政策研究学习，取其政策精髓，完成公司全体人员索技能培训,负责各品牌三包索赔服务单据提报及跟踪结算,负责上下游客户索赔业务链接，保证上下游客户满意度。</p>
        <p>7、维修公司：负责所经营品牌24小时维修服务保障工作，对事业部总监负责。</p>
        <p>8、销售公司：负责配件、整车、工时销售及客户维护开发工作，服从总监工作安排。</p>
        <p>9、车险业务公司：负责事故车业务开发、客户信息收集、保险公司业务对接、定损流程制定、转介绍业务积分发放，服从总监工作安排。</p>
        <p>10、仓储物流科：负责经营品牌库房配件管理工作，服从总监工作安排。 </p>
        <p></p>
        <br/>
        <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure63' title="《云豪车服管理公司各岗位职责》" onClick={(value)=>this.showDrawer(value)}>《云豪车服管理公司各岗位职责》</a></div>
        <br/>
        <h3 name="0-5-1-2-2" className="point" id="0-5-1-2-2">第三部分 云豪车服管理公司内部管控流程及标准</h3>
        <h4 name="0-5-1-2-2-0" className="point" id="0-5-1-2-2-0">一. 云豪车服管理公司各部室管理细则</h4>
        <h4>（一）管理公司通用：</h4>
        <p>1、所有人员7：45准时参加晨会，未按时参加考核20分/次，记录积分痕迹。</p>
        <p>2、所有人员确保业务电话24小时畅通，否则考核50分/次，记录积分痕迹。</p>
        <p>3、工作期间没有主管领导同意擅自离岗，考核50分/次，记录积分痕迹。</p>
        <p>4、管理公司下达所有通知认真阅读、严格执行，否则考核50分/次，记录积分痕迹。</p>
        <h4>（二）维修公司：</h4>
        <p>1、上岗前所有人员必须穿云豪车服工装、符合云豪车服职业形象，否则考核30分/次，记录积分痕迹。</p>
        <p>2、外服人员必须穿着干净、整洁专用工装、符合云豪车服职业形象，否则考核30分/次，记录积分痕迹。</p>
        <p>3、工作区域卫生、值日人员上班第一时间负责打扫干净、整洁，符合云豪车标准，否则考核30分/次，记录积分痕迹。</p>
        <p>4、所有维修人员严格服从主管领导安排的临时工作，夜间救援服务无条件执行、如：电话无法接通、推诿等，不执行人员，考核100分/次，记录积分痕迹。</p>
        <p>5、每日外出完成后清理好车内外卫生、所使用工具归还摆放整齐、物料归还，否则考核50分/次，记录积分痕迹。</p>
        <p>6、外服技师每日出车前对服务车辆全面检查并做好外出登记，否则考核50分/次，记录积分痕迹。</p>
        <p>7、车辆负责人对服务车辆定期保养维护及安全检查，否则考核50分/次，记录积分痕迹。</p>
        <p>8、提供24小时服务、保质保量完成维修任务、不得造成客户投诉，否则考核100分/次，记录积分痕迹。</p>
        <p>9、车间维修人员在维修操作期间应做好车辆及人身安全保护措施，避免发生安全事故。若在维修期间发生一起安全事故，考核当事人、维修分队长、维修公司经理每人200分/次，记录积分痕迹。</p>
        <h4>（三）销售公司：</h4>
        <p>1、本事业客户信息汇总、梳理，每周周报上传附件，否则考核50分/次，记录积分痕迹。</p>
        <p>2、每周推出一个营销方案、图文并茂，否则考核50分/次，记录积分痕迹。</p>
        <h4>（四）车险业务公司：</h4>
        <p>1、24小时提供出现场服务、不得造成客户及保险公司投诉，否则考核100分/次，记录积分痕迹。</p>
        <p>2、提供代办业务、（外堪申请、理赔申请等），不得造成客户及保险公司投诉，否则考核100分/次，记录积分痕迹。</p>
        <p>3、车险业务车辆维修前必须录入公安网、维修完毕必须录入修管所维修管理系统、打印合格证自行留存，否则考核100分/次，记录积分痕迹。</p>
        <h4>（五）服务科：</h4>
        <p>1、客户接待登记（必须录入公安网、维修完毕必须录入修管所维修管理系统）、环节跟进，人员不足情况下要主动与客户沟通预约维修时间、不得造成客户投诉，否则考核30分/次，记录积分痕迹。</p>
        <p>2、服务科接到派工10分钟内响应与客户联系、系统对应的工单进行接单和派工处理，否则考核20分/次，记录积分痕迹。</p>
        <p>3、派工单关闭：工单开始至结束不得超过24小时，如有调件或大修发动机等，24小时无法完成，
            特殊情况需向400反馈并备案（留取证据），跟踪维修公司人员关闭工单时需电话跟踪关闭情况，必须符合服务政策运营指标，否则考核100分/次，记录积分痕迹。</p>
        <p>4、所有服务必须对客户100%进行电话回访（服务满意度、服务及时性、故障是否解决处理等），否则考核10分/次，记录积分痕迹。</p>
        <p>5、报单及时率：所有单据完工后24小时内、必须系统填报完毕；否则考核10分/次，记录积分痕迹。</p>
        <p>6、下班前必须完成当天旧件整理、清点、旧件标签必须实时悬挂，严格按照厂家要求返还旧件，否则考核20分/次，记录积分痕迹。</p>
        <p>7、报单准确率：所有单据填报必须符合各厂家服务政策，填报信息必须准确无误，退回单据12小时内完成修改，否则考核20分/次，记录积分痕迹。</p>
        <p>8、所有服务调货必须做到和仓储人员一对一对接，并对调件客户信息进行统计、实时跟进调货情况、不得造成服务延误或客户投诉，否则考核50分/次，记录积分痕迹。</p>
        <p>9、索赔报单照片要求：</p>
        <p>整车需要照片：5张保修手册、行驾驶本、整车车头、整车铭牌、里程表（适用所有品牌）</p>
        <p>故障照片：拆装前、拆装中、拆装后</p>
        <p>完工照片：新旧件合影、新旧件流水号、安装后、手工单</p>
        <p>简称：整车照片+故障照片+完工照片=正常服务照片</p>
        <p>如有维修配套厂加配套厂标牌；</p>
        <p>潍柴：正常服务照片+发动机铭牌及钢印</p>
        <p>法士特：正常服务照片+变速箱铭牌</p>
        <p>汉德：正常服务照片+桥铭牌</p>
        <p>福伊特：正常服务照片+变速箱铭牌</p>
        <p> 重汽：正常服务照片+视频（正常服务照片连起来录制，录两段录制）</p>
        <p> 欧曼：正常服务照片+视频</p>
        <p>正常保修照片角度要求：</p>
        <p>⑴整车照片1张（整车左/右前方45°角，突出周围环境，自备车外服务整车照需包括服务车辆）；</p>
        <p>⑵里程表远景照片1张（须看清数字并突出仪表盘）；</p>
        <p>⑶车辆铭牌或大梁号照片1张；</p>
        <p>⑷故障件拆装前近景、远景照片各1张（近景需体现损坏部位，远景需体现周围环境）；</p>
        <p>⑸故障件拆装过程近景、远景照片各1张； （近景需体现损坏部位，远景需体现周围环境）；</p>
        <p>⑹修复后（能看清修复的故障部位及周围环境）照片1张；</p>
        <p>⑺服务记录单照片；</p>
        <p><strong>备注：以此类推试用所有服务品牌照片要求。
以上为索赔服务照片要求，如因维修技师个人原因导致照片缺少或不合格考核50分/次，记录积分痕迹。</strong></p>
        <h4>(六)仓储物流科</h4>
        <p>1、按公司要求学习ERP系统的具体工作流程和正确使用的方式方法、必须严格正确使用ERP系统，系统使用严格执行公司规定，否则考核50分/次，记录积分痕迹。</p>
        <p>2、维修单据、销售单据必须实时出库、客户信息、配件明细必须准确无误，否则考核50分/次，记录积分痕迹。</p>
        <p>3、索赔单据12小时内完成索赔出库、必须准确无误，否则考核50分/次，记录积分痕迹。</p>
        <p>4、严格执行各厂家、配件系统出入库规定、必须满足厂家政策，否则考核50分/次，记录积分痕迹。</p>
        <p>5、领退料登记必须清楚（件号、名称、数量、车辆信息、人员、时间），否则考核50分/次，记录积分痕迹。</p>
        <p>6、区域负责人每天下班前必须完成所负责区域配件整理、摆放、清点等，否则考核50分/次，记录积分痕迹。</p>
        <p>7、下班后个人办公区域禁止有任何物料，否则考核50分/次，记录积分痕迹。</p>
        <p>8、必须按各品牌商务政策做好配件置换，否则考核50分/次，记录积分痕迹。</p>
        <p>9、到货配件清点记录（件号、名称、数量）实时入库，必须准确无误，否则考核50分/次，记录积分痕迹。</p>
        <p>10、提供24小时服务、保质保量完成配件备货及销售任务、不得造成客户投诉，否则考核100分/次，记录积分痕迹。</p>
        <h4 name="0-5-1-2-2-1" className="point" id="0-5-1-2-2-1">二、 24小时值班轮岗、备岗</h4>
        <p>为更好的服务好每一位客户，云豪车服对外承诺24小时服务，管理公司所有人员保证手机24小时开机、值班人员严格准守值班制度，考核200分/次、记录积分痕迹。</p>
         <img src={daxingchefuzhibanbiao} alt="" style={{width  : '800px',display: 'block',margin : '0 auto'}}/> 
        <h4 name="0-5-1-2-2-2" className="point" id="0-5-1-2-2-2">三、 安全驾驶激励政策</h4>
        <p>由于目前云豪车服管理公司外出服务车辆较多，为了有效提升安全，特制定以下激励政策，驾驶员应文明驾驶（不违反任何道路交通安全法）
            且行驶里程在部门驾驶员前三名的，给予每人200分/次、记录积分痕迹（每季度考评一次），驾驶员由于个人驾驶造成交通违章
            （闯红灯、未系安全带、超速、违规停车等驾驶员违规操作），驾驶员除依法承担交通处罚外，管理公司额外，考核50分/次、记录积分痕迹。</p>
        <h4 name="0-5-1-2-2-3" className="point" id="0-5-1-2-2-3">四、 执行力</h4>
        <p>云豪车服管理公司岗位责任书第7条，明确规定负责完成上级领导安排的各项临时工作，再次补充：上班期间领导安排的各项工作必须服从执行，出现一次拒绝执行上级工作指令，考核200分/次、记录积分痕迹。</p>
        <h3 name="0-5-1-2-3" className="point" id="0-5-1-2-3">第四部分 云豪车服管理公司收入分配细则</h3>
        <img src={yunhaochefushourufenpeixize} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <p>1、岗位：维修技师=职级工资+固定积分收入+动态积分收入+定额积分工时绩效提成+（整车及销售配件提成）</p>
        <p>2、岗位：服务科科长=职级工资+固定积分收入+动态积分收入+三包索赔当月有效结算绩效提成%+（整车及销售配件提成）</p>
        <p>3、岗位：客服专员=职级工资+固定积分收入+动态积分收入+三包索赔当月有效结算绩效提成%+（整车及销售配件提成）</p>
        <p>服务科绩效积分构成=服务科绩效总积分、按业务专员岗位技能进行分配。</p>
        <p>服务科科长必须了解各品牌的服务政策同时负责各品牌服务单的及时填报和各项报单质量。</p>
        <p>4、岗位：仓储物流科成员=职级工资+固定积分收入+动态积分收入+配件出库量绩效% +营业外收入%+（整车销售积分）</p>
        <p>仓储科根据配件销售维修销营业额积分，按仓储管理员岗位技能进行分配</p>
        <p>5、岗位：维修公司经理=承包收益（完成任务指标）+（整车销售积分）</p>
        <p>6、岗位：销售公司经理=承包收益（完成任务指标）+（整车销售积分）</p>
        <p>7、岗位：销售专员=职级工资+固定积分收入+动态积分收入+销售提成%+（整车销售积分）</p>
        <p>8、岗位：事故车业务经理=承包收益（完成任务指标）+（整车销售积分）</p>
        <p>9、岗位：车间物业管理科=职级工资+固定积分收入+动态积分收入+业绩提成+（整车销售积分）</p>
        <p>10、岗位：统计科=职级工资+固定积分收入+动态积分收入+业绩提成+（整车销售积分）</p>
        <p>统计科/车间物业管理科: 业绩提成=事业部营业额（不含内部调拨）%</p>
        <p>11、岗位：总监=承包收益+（整车销售积分）</p>
        <p>12、岗位：云豪车服总经理=承包收益+（整车销售积分）</p>
        <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure64' title="《云豪车服动态积分考核表》" onClick={(value)=>this.showDrawer(value)}>《云豪车服动态积分考核表》</a></div>
        <h4 name="0-5-1-2-3-0" className="point" id="0-5-1-2-3-0">一、 绩效提成</h4>
        <img src={chefujixiaoticheng} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <h4 name="0-5-1-2-3-1" className="point" id="0-5-1-2-3-1">二、 维修事故考核标准</h4>
        <img src={weixiushigukaohebiaozhun1} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <h4 name="0-5-1-2-3-2" className="point" id="0-5-1-2-3-2">三、 维修技能等级标准：</h4>
        <p>A取得云豪学院颁发的所有工匠证、具有技术攻关、技术创新、维修工具创新、具有新技术培训指导、具有团队领导力、协调统筹能力。9级</p>
        <p>B熟悉汽车构造原理，具有丰富的维修经验（具备较好的诊断能力、广泛的机械设备维修能力），安全驾驶服务车的能力，
            能够独立处理疑难杂症，国六产品（燃油、天然气）理疑故障处理、具备客户沟通、获取信息及销售能力，有较好的指导协调统筹能力、配件销售能力。7-8级</p>
        <p>C能独立完成总成件拆装解体大修，具备初步的故障诊断能力，能够处理常见故障，具有专项品牌维修能力，国六产品（燃油、天然气）日常故障处理、具备指导沟通协调能力。5-6级</p>
        <p>D能熟练掌握常规小修项目拆装如：差速器总成、变速箱总成、离合器总成、制动器、传动轴、方向机、板簧、气囊、发动机附件及底盘附件具备地盘常见故障的检修能力.3-4级</p>
        <p>E能够独立完成S级保养及检查，小修项目配件拆装。2-3级</p>
        <h3 name="0-5-1-2-4" className="point" id="0-5-1-2-4">第五部分 云豪车服管理公司专用条款作业流程</h3>
        <img src={chexianyewucaozuoliucheng} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        
        <h4 name="0-5-1-2-4-0" className="point" id="0-5-1-2-4-0">一、 车险业务作业流程细则：</h4>
        <p>1、接到车险信息：</p>
        <p>（1）在车辆可以行驶的情况下，安排车辆进厂。</p>
        <p>（2）在车辆无法行驶的情况下，安排拖车拖回。</p>
        <p>2、客户服务科做维修接车登记。</p>
        <p>3、轻微事故，事故专员做外观鉴定，做现场评估。</p>
        <p>4、事故专员车损配件登记、维修项目登记。</p>
        <p>5、仓储管理员对车辆损坏配件报价，事故专员汇总维修工时报价。（维修工时及配件总报价）</p>
        <p>6、不走保险的车辆与客户维修确认，走保险的报保险公司核损。</p>
        <p>7、重大事故车辆，维修公司经理安排拆解检查派工。</p>
        <p>8、维修分队长接单，拆解事故车辆进行车损鉴定。</p>
        <p>9、事故专员登记车损配件及维修项目单。</p>
        <p>10、由仓储支持做配件报价，事故专员汇总工时及配件总报价，报保险公司核损。</p>
        <p>12、维修分队长接单事故车维修。</p>
        <p>13、仓储支持反馈配件信息，维修领取配件，缺件进行区域调拨及厂家进货。</p>
        <p>14、维修完工，维修公司经理做完工检验及试车。</p>
        <p>15、事故专员负责跟进生成维修单，客户结算，开发票。</p>
        <p>16、维修结算完毕，事故专员为客户提供保险相关手续，指导客户到保险公司完成保险结算。</p>
        <br/>
        <h4 name="0-5-1-2-4-1" className="point" id="0-5-1-2-4-1">二、 全员事故车业务激励办法</h4>
        <p> 2020年为更加合理利用集团公司人力资源、客户资源、品牌资源、维修资源，把事故车业务发展壮大，云豪车服管理公司特制定《全员车险业务介绍激励办法》，具体细则如下：</p>
        <p>1、实施时间：</p>
        <p>2020年1月1日-2020年12月31日</p>
        <p>2、兑现单位：</p>
        <p>车险业务介绍由各事业部统计上报管理公司审核后提交集团公司财务部审批，因奖励所产生的费用全部计算在各维修事业部成本中。</p>
        <p>3、奖励细则：</p>
        <img src={chefujianglixize} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <p>说明：</p>
        <p>1、提供的信息，必须实现维修。</p>
        <p>2、所有奖励均为动态积分奖励增加至次月当事人的动态积分中。</p>
        <img src={shiguchejieshouren} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <h4 name="0-5-1-2-5" className="point" id="0-5-1-2-5">第六部分 云豪创业空间-创业班组试运行方案及管理细则</h4>
        <h4 name="0-5-1-2-5-0" className="point" id="0-5-1-2-5-0">一、 创业班组试运行方案</h4>
        <h4>“人”</h4>
        <p>1、创业空间班组人员由延庆和大兴车服事业部各抽调一组（具体人事任命安排由云豪创业空间决定）。</p>
        <p>2、班长为第一责任人，每班组为2人。</p>
        <p>3、班组长要求： </p>
        <p>⑴从事重卡维修行业3年以上维修经验，拥有车辆C1驾驶证，具有良好的沟通能力； </p>
        <p>⑵具备独立的故障判断及维修能力，具有基础的气路、电路维修能力及后处理维修能力。</p>
        <p>⑶拥有专业维修站工作2年以上经验或取得云豪学院工匠认证者优先。</p>
        <p>⑷具备总成件中修能力（发动机、变速箱、差速器及底盘）。</p>
        <p>4、班长的人事任命最终决定权由云豪创业空间经理决定。</p>
        <h4>“财”</h4>
        <p>1、收入分配机制：</p>
        <p>营业收入为：各品牌三包服务（工时费、出车费和外出补助）+保外服务（维修工时费、出车费和维修配件利润）+销售配件提成（按照销售额2%提成）。
经营费用为：应急保障车间费用+燃油费+高速费+应急保障车间维护费+餐费+耗材。</p>
        <p>2、班组收入=（毛利润－经营费用）X制定的分成比例（云豪创业空间占4:班组占6）-应急保障车间费用（每公里0.5-0.7元）。</p>
        <p>班长收入 =班组收入÷20X12+应急保障车间费用－社保。</p>
        <p>班副收入=班组收入÷20X8－社保。</p>
        <p>3、班组人员，首月发放固定收入，次月按照班组实际收入发放。</p>
        <p>4、班组人员保险（社保、意外险等）由公司统一缴纳。</p>
        <p>5、保外服务收款方式（财务指定微信二维码/现金代收）每天与财务对接人员核对，无欠款权力。</p>
        <h4>“物”</h4>
        <p>1、车间为皮卡改装。</p>
        <p>2、保障车间销售给班长（0首付，分48期还款支付），车辆保险费由班长承担。</p>
        <p>3、班组需要和云豪创业空间签订一份承包合同和车辆买卖协议。</p>
        <p>3.1 班组收费服务标准遵循云豪车服统一收费服务标准并严格执行。</p>
        <p>4、各项经营数据单独统计实现独立核算管理模式。</p>
        <p>5、维修销售配件统一由云豪车服提供，实行统一的销售政策及销售价格。</p>
        <p>6、保外服务：遇到配件销售时，联系云豪创业空间调度统一报价，禁止第一现场直接给客户随意报价及收取任何的额外费用，一经发现根据情况处以500-5000元的考核。</p>
        <p>7、报修项目与实际维修项目产生差异，需要反馈调度科重新报价。</p>
        <h4>“产”</h4>
        <p>1、日常业务由大兴、延庆车服维修公司派工给云豪创业空间调度科。</p>
        <p>2、大兴、延庆车服维修公司优先派工给云豪创业空间调度科，保证云豪创业空间班组业务量充足。</p>
        <p>3、班组各项业务由云豪创业空间指派和自我开发（开发业务需要服务时反馈给云豪创业空间，实行统一派工 ）。</p>
        <p>4、班组生产服务与客户沟通需文明用语。</p>
        <h4>“销”</h4>
        <p>1、可兼职销售云豪平台其它的产品（整车、零部件、保险、事故车业务介绍）实现班组及个人的收入提高。</p>
        <p>2、能够实现客户报修10分钟回复，2小时到达客户现场的高效服务。</p>
        <h4 name="0-5-1-2-5-1" className="point" id="0-5-1-2-5-1">二、 创业班组管理细则</h4>
        <h4>“人”</h4>
        <p>1、班组日常工作及行政工作统一由云豪创业空间管理。</p>
        <p>2、班长为第一责任人，负责班组日常的各项工作分配和协调。</p>
        <p>3、班长对安全生产负主要责任，确保生活和工作做到防患于未然，生产中对安全防护检查，对不服从安全管理者有考核权力。</p>
        <p>4、严格遵守云豪集团《员工手册》。</p>
        <h4>“财”</h4>
        <p>1、班长与云豪创业空间负责人，日、周、月进行汇报及核对支出、收入数据。</p>
        <p>2、班组对外收费服务标准遵循云豪创业空间服务科统一收费服务标准严格执行，如私自调整价格每发现一起给予10倍考核，情节严重者追究法律责任。收费服务需如实填报客户信息/收款金额并及时汇总上报（24小时内上报如超时按照漏报计算），出现漏报情况给予负激励1000元/次考核。</p>
        <p>3、云豪创业空间统计科与班长对每天的服务及单据进行统计核对并上报总监，次日未上报考核100分/次。</p>
        <p>4、保外服务收款方式（财务指定微信二维码/现金代收）每天与创业空间统计人员核对，创业空间班组无欠款权力（如总监同意欠款，必须填写维修证明）；班长欠款直接从当月发放收益中扣除。</p>
        <p>5、维修和销售配件统一由公司提供，实行统一的销售价格，每违反一起给予10倍考核。</p>
        <h4>收入构成：</h4>
        <p>营业收入为：各品牌三包服务（工时费、出车费和外出补助）+保外服务（维修工时费、出车费和维修配件利润）+销售配件提成（按照销售额2%提成）。
经营费用为：应急保障车间费用+燃油费+高速费+应急保障车间维护费+餐费+耗材。</p>
        <p>2、班组收入=（毛利润－经营费用）✖制定的分成比例（云豪创业空间占3:班组占7）-应急保障车间费用（每公里0.5元）。</p>
        <p>班长收入 =班组收入÷20X12+应急保障车间费用－社保。</p>
        <p>班副收入=班组收入÷20X8－社保。</p>
        <h4>“物”</h4>
        <p>1、保障车工具设备日常维护盘点补充（每月盘点一次），确保维修工作正常开展（按照原始交接清单盘点，出现丢失缺损7天内补齐，未按照时间节点补齐给予200分/次考核）。</p>
        <p>2、销售配件管理：做好配件支出台账，每周一次对配件盘点与仓储库房核对及补充，确保账物一致零误差（由于管理出现误差按照等值扣款）同时确保新配件包装干净整洁如影响二次销售考核50分/件。</p>
        <h4>“产”</h4>
        <p>1、云豪车服品牌推广，每完成一次服务微信朋友圈宣传一次（漏发一次考核班组成员每人20分）。</p>
        <p>二类照片合影：</p>
        <p>①故障车、应急保障车、客户、服务人员，合影照片（45°整洁清晰照片）。</p>
        <p>②准作业现场合影（照片中包含维修技师作业过程，整洁清晰照片）。</p>
        <p>1、的各项维修任务高效、高质量完成（能够实现客户报修10分钟内联系客户，1小时到达客户现场，小修2小时解决故障，中修4小时解决故障）。</p>
        <p>2、维修作业标准按技术管理制度《维保作业工艺切块管理细则》及云豪车服管理公司《专项维修细则》进行维修作业，如不符合作业标准考核100分/次。</p>
        <p>3、作业过程中出现返工（由云豪车服管理公司技术标准部鉴定）属于技术或装配原因所有费用由班组按照客户要求承担，属于配件质量问题由云豪创业空间解决。</p>
        <h4>“供”</h4>
        <p>1、外采配件时上报云豪创业空间申请同意后即可采购维修。</p>
        <p>2、配件携带不足时，为了提高服务时效，平台会选择快递（闪送或专车）配送。</p>
        <p>3、过程中合理统筹安排各项派工，确保一车多单服务模式，实现利润最大化，降低经营成本。</p>
        <p>“销”</p>
        <p>1、了解市场变化情况，收集客户需求，制定合理的服务经营模式（每周周报形式汇报）。</p>
        <p>2、销售云豪平台其它产品（整车、零部件、车险业务）实现班组及个人的收入提高。</p>
        <p>3、维护客户关系，同时开发新客户，提升保外维修业务。</p>
        <p>4、客户维系：</p>
        <p>⑴负责开发、维护区域客户关系促成长期的良好的合作关系。</p>
        <p>⑵每天汇总经营情况（参照创业空间信息反馈表）至管理公司。</p>
        <p>⑶不得造成客户有效投诉，如造成客户投诉考核50分/次。</p>
        <p>5、调度科负责对每起服务百分之百进行回访，形成回访记录表（24小时内完成）。</p>
        <h4>职业形象</h4>
        <p>1、用语（接打电话：您好！云豪车服维修技师XX为您提供服务， 您车有什么问题需要服务？很高兴为您服务！再见！ 未按照此标准考核10分/次 ）。</p>
        <p>2、仪表干净整洁。</p>
        <p>3、穿戴云豪车服创业空间指定工装，保持干净整洁，每月必须购买1套（未按标准着装考核100分/次）。</p>
        <p>4、保障车做到外观及内饰干净整洁；（未做到考核50分/次）。</p>
        <p>5、工具及设备实时干净整洁、摆放到指定位置；（未做到考核50分/次）。</p>
        <p>6、现场和过程必须保持配件及工具摆放整齐；（未做到考核50分/次）。</p>
        <p>7、作业必须给客户车辆做到卫生防护：座套、脚垫、把套；（未做到考核50分/次）。</p>
        <h4>八、安全规范</h4>
        <p>1、安全文明驾驶严格遵守《道路交通安全法》违法事项按照云豪集团《员工手册》相关条例执行。</p>
        <p>2、维保作业未按《员工手册》第四章安全管理制度及云豪车服专项条款执行，按《员工手册》考核。</p>
        <p>3、班组人员每人必须有意外保险，车辆必须有商业保险（按照创业空间要求购买）。</p>

        <br/>
        <h3 name="0-5-1-3" className="point" id="0-5-1-3">2021年云豪集团云豪备品管理公司组织结构图及管理层人事安排</h3>
        <h4 name="0-5-1-3-0" className="point" id="0-5-1-3-0">一、云豪备品管理公司组织机构图</h4>
        <img src={peijian11} alt="" style={{ width  : '800px', display: 'block', margin : '0 auto' }}/>
        <h4>二、云豪备品管理公司管理层人事安排：</h4>
        <h4>一、管理公司本部</h4>
        <p><strong>1、总经理：</strong>孟庆彪，全面负责该公司人、财、物、产、供、销，为该管理公司的第一责权人，向董事长汇报工作。</p>
        <p><strong>2、副总经理：</strong>苗东，主管海外市场业务，兼任沙特 NOR MOTORS 公司总经理、迪拜 NOR MOTORS公司总经理，针对云豪备品管理公司业务向总经理汇报工作，配合总经理完成本管理公司出口工作。有权指挥管理公司下级职员配合工作。</p>
        <p><strong>3、副总经理：</strong>李信，主管仓储物流部，监管采购部，向总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>二、行政部专员：  </strong></p> <p>田银，负责管理公司人员招聘、职业规划、员工关怀；落实量化各部室合同执行、流程标准落地、周度、月度指标完成情况；对接集团人力资源部和办公室工作，向总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>三、采购事业部</strong></p>
        <p><strong>总监：</strong>朱莹莹（三级），负责云豪备品管理公司采购工作及销售政策的制定，品牌方政策解读及运用，对库存结构负责，为采购事业部第一责权人，对总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>副总监： </strong>马松岩，主管开发科，向事业部第一责权人汇报工作，服从上级领导的工作安排。</p>
        <p><strong>计划科 科长：</strong>吕婷，负责品牌中心库的采购计划，销售政策的跟踪，品牌方政策解读及运用，对库存结构负责，向总监汇报工作，服从上级领导的工作安排。</p>
        <p><strong>开发科  负责人：</strong>马松岩（兼）负责非品牌中心库厂家之外的配套件开发。</p>
        <p><strong>四、销售事业部</strong></p>
        <p>销售事业部业务范围： 满足市场人员或直接客户及用户提报的订单需求，实现销售闭环，负责落实财务闭环，负责客户跟踪及回访 ，负责市场人员销售业绩统计，与销售有关的一切支持工作。</p>
        <p><strong>总监：</strong>刘天双（二级），负责该事业部全面工作，为销售事业部第一责权人，向总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>销售一科  科长：</strong>谢佳，同时负责销售二科、三科日常销售工作并形成闭环，向事业部总监汇报工作，服从上级领导工作安排。</p>
        <h4>五、市场部 </h4>
        <p>市场部业务范围：负责终端用户及客户开发，品牌配件及云豪备品推广，二网、三网及配件营销创业空间的发展与维护，负责落实财务闭环，与云豪车服APP事业部紧密合作。</p>
        <p><strong>总监：</strong>周文青（一级），负责市场部全面工作，为市场部第一责权人，向总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>副总监：</strong>汪振清，向总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>副总监：</strong>李敬东，向总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>区域销售经理：</strong>由事业部总监根据实际情况分配。</p>
        <h4>六、物流仓储部 </h4>
        <p><strong>总监：</strong>李信（兼），为该部门第一责权人，向总经理汇报工作，服从上级领导工作安排。</p>
        <p><strong>副总监：</strong>樊翠艳，对总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>物流科 科长 </strong>张东伟，负责物流科、仓储科、旧件科工作形成闭环，对对总监汇报工作，服从上级领导工作安排。</p>
        <p><strong>副科长：</strong>张晓伟，负责延庆库日常工作，向科长汇报工作，服从上级领导工作安排。</p>
        <p>统计科 负责人：樊翠艳（兼），对总监汇报工作，服从上级领导工作安排。</p>
        <h4>七、品牌管理委员会</h4>
        <p>朱莹莹：潍柴中心库、北奔中心库、盖茨品牌</p>
        <p>刘天双：陕汽中心库、威伯科中心库、汉德中心库</p>
        <p>周文青：法士特中心库、伊顿离合器中心库</p>
        <p>汪振清：重汽轻卡中心库</p>
        <p>李敬东：重汽重卡中心库</p>
      
        <h3 name="0-5-1-3-1" className="point" id="0-5-1-3-1">4.2 配件业务管理公司内部管控细则</h3>

        <div style={{ textIndent: '2em' }}>
            <h4>一、专用条款内部管控流程</h4>
            <h4 name="0-5-1-3-1-0" className="point" id="0-5-1-3-1-0">1. 计划部：</h4>
            <p>1.1 基于计划部（集采）完成对市场二级配套、三级配套厂家信息收集，按照月度制定工作量，可检视；</p>
            <p>1.2 定向采购（和供方有年度正规采购合同的），对于供方的开发应召开配件管理公司采购专项会议讨论是否纳入供方体系。</p>
            <p>1.3 非定向采购（无固定的采购合同的），应形成正式的书面报告上报需求部门总监签字、管理公司总经理签字后方可采购。</p>
            <p>1.4 计划部对采购到货的配件差异负监管责任，并负责与供方协调直到问题解决。</p>
            <p>1.5 品牌中心库针对加急调拨到货要快速实现出库，体现“加急时效”；仓储物流部按照正常入库流程完成入库；</p>
            <p>1.6 整合管理公司各部室计划人员，成立计划工作群，对各部室日常采购工作标准的执行情况进行监督。</p>
            <p>1.7 通过展销会收集、内部原有采购渠道收集、市场走访、行业信息建立完善配件公司采购体系：现有资源潍柴、陕汽、法士特、重汽、欧曼、现有资源80%外协件原厂配套采购渠道，完成50%常用件二级供应商采购渠道开发；客车（宇通、苏龙、金旅、中通、亚星等）供应商完成60%原厂配套商渠道开发，完成50%常用件二级供应商渠道开发；海外订单完成农机、装载机、挖掘机、推土机、发电机机组等专用设备橡胶类、液压类、工具类、易损件及专用件采购渠道建立，保证年末海外订单满足率不低于70%；国内采购订单满足率年底不低于80%；截至2019年末采购部成为集团公司配套商采购性价比最具竞争力部门；</p>
            <p>1.8 截至2019年末建立可执行、可落地的采购流程、招标方案；根据客户、市场需求，市场调研主动收集、招标，完成集团公司有效可执行的采购流程 ；建立初始供应商数据库（包含图文）不断更新每周以周报添加附件发送到管理公司；截至2019年末该数据库能够满足集团公司海内外配件需求订单70%满足率；</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4 name="0-5-1-3-1-1" className="point" id="0-5-1-3-1-1">2. 销售配件索赔</h4>
            <br/>
            <img src={peijiansuopei641} alt="" style={{
                width  : '70%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={peijiansuopei642} alt="" style={{
                width  : '70%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <img src={peijiansuopei643} alt="" style={{
                width  : '70%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>关于销售配件根据中心库渠道索赔政策、集采配套商务政策，要求及时解决销售过程中配件索赔，48小时完成鉴定、5个工作日解决，未解决的上报管理公司；
未按规定执行对应负责人考核100分。</p>

            <br/>
            <h4 name="0-5-1-3-1-2" className="point" id="0-5-1-3-1-2">3. 质量检验：</h4>
            <h4>3.1 效率提升</h4>
            <p>通过货位、货区、库存结构调整，完成月度效率核算（备货需要标准起始时间），通过效率核算仓储物流部产能，为增加人员提供数据支持；相关数据上报管理公司统计部；周期：月度，负责人：仓储事业部对应责任人 </p>
            <h4>3.2 货位完整率</h4>
            <p>精准货位是提高效率、新人能够快速进入状态依据，维护货位数据是区域备货员能力体现，出现错误频繁调整为效率提升、库存差异造成障碍，统计部每周两天抽查货位准确性，对于抽查内容进行优化；准确率不低于已定货位90%；责任人：仓储物流事业部对应责任人</p>
            <h4>3.3 库区优化</h4>
            <p>先进先出，针对备货区域、储存区位置及备货时走动距离进行货位调整，出库频次高、出库量大的应更靠近备货区方便取、入，根据历史数据留有足够空间；滞销产品远离备货区紧凑管理；每周提报货位优化明细，上报管理公司；周期：月度，负责人：仓储事业部对应责任人</p>
            <h4>3.4 出库频次、库龄</h4>
            <p>为更好优化库区，将缓动产品优化货位并将优化明细上报管理公司；周期：月度，负责人：仓储事业部对应责任人。</p>
            <h4>3.5 责任人</h4>
            <p>仓储物流部每周五上报检验结果到管理公司，根据出错配件逐项分析出错原因24小时内完成优化，在货位或卡片标注“易出错”，责任人：仓储事业部对应责任人
未按规定执行对应负责人考核100分</p>
            <br/>
            <h4 name="0-5-1-3-1-3" className="point" id="0-5-1-3-1-3">4. 物资安全</h4>
            <h4>4.1 到货差异</h4>
            <p>4.1.1 仓储物流事业部对厂家到货进行检验核对工作，并形成差异报告并报给中心库，不完整货物不得进入仓储库房。周期：每批入库计划，负责人：仓储事业部对应责任人</p>
            <p>4.1.2 计划科集中入库并将异议件销售到 “中心库采购异议”，由中心库采购完成追溯；3个工作日内上报总监处理结果并在差异报告签字留档；周期：每批入库计划，负责人：中心库对应责任人</p>
            <p>4.1.3 仓储物流事业部出具完整检验标准，现场整理标准，保证检验准确度；仓储区域管理员为一级检验，出库检验为二级检验，复检出现差异者</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <h4>4.2 滞销件明细（库龄）</h4>
            <p>中心库以半年为周期上报积压配件明细，根据明细中心库、管理公司寻求解决办法，降低库存积压；</p>
            <h4>4.3 装卸车损坏，包装不当损坏</h4>
            <p>4.3.1 由个人操作不当造成的配件损坏，按照采购价的50%开具销售单出库。</p>
            <h4>4.4 退库流程</h4>
            <p>4.4.1 已销售到客户的配件退库</p>
            <h4>4.4.1.1 目的：</h4>
            <p>配件公司所有工作基于实现销售、保证物资安全，针对以销售尽量不要产生订单，针对客户退库认真分析退库原因不断提高客户满意度及客户需求；杜绝现在电话沟通退库不能及时跟进无人监管现状；</p>
            <h4>4.4.1.2 范围：</h4>
            <p>通过正常流程销售到客户的配件产生退库的（不包含索赔件、意外损坏件）按照此流程执行；</p>
            <h4>4.4.1.3 退库单生成：</h4>
            <p>1、品牌中心库根据客户退单诉求详细了解退单原因，自己生成或客户生成退库明细综合考虑必须请示品牌总监是否可以退库，批量退库需上报管理公司（根据明细可以通过视频照片初步判断退库配件状态）；</p>
            <p>2、了解客户发送时间、承运单位（快递、物流配送、沿途配送捎回、业务捎回等）、物流单号（方便仓储收货对应）、此时告知客户收货人为仓储人员（仓储指定同仓储退库对接人为一个人）；同时告知客户包装内付与中心库已核对的清单</p>
            <p>3、品牌中心库生成配件公司《到达客户后配件退库单》并登记相关信息：退库编号（年度第几张）、品牌中心库名称、退库对接人（事业部指定基本不变）、仓储对接人（事业部指定基本不变）、客户单位（全称同步怀远）、预计发送时间、预计到达时间、物流方式、退件明细（原销售单号、名称、件号、预退数量）、退库原因；</p>
            <p>4、品牌中心库将《到达客户配件退库单》以电子版形式发送到“配件公司索赔、损坏、退库群”并保证仓储“退库对接人”收到；原则：该退库单应早于实物到达仓储“退库对接人”手中；</p>
            <h4>4.4.1.4 收到实物检验与确定</h4>
            <p>1、仓储物流部及“对库对接人”打印《到达客户配件退库单》（三联），根据《到达客户后配件退库单》信息及时跟进仓储退库到货，并按照入库流程核实退库明细中件号、实物、数量，原则不影响销售；有问题的（预退数量与实收数量不符的、严重损坏的）第一时间以影像方式反馈到中心库“退库对接人”第一时间反馈到客户；</p>
            <p>2、仓储物流部及“退库对接人”根据客户退库实物如实填写《到达客户后配件退库单》并登记相关信息：实收数量、合格数量（不影响销售的视为合格）、备注（检验结果简单阐述清楚）、检验签字确认、仓储负责人签字确认（总监、副总监、科长）；第一时间将《到达客户配件退库单》以电子版形式发送到“配件公司索赔、损坏、退库群”并保证品牌中心库“退库对接人”收到；</p>
            <p>3、仓储物流部对客户到货物资有管理责任，原则：24小时完成检验，批量退库酌情延长；</p>
            <h4>4.4.1.5 退库销售单生成</h4>
            <p>1、中心库及“退库对接人”根据仓储检验结果有异议的第一时间对接客户沟通确定最终退库结果并开具销售单（退库单）；无意义可直接开具销售单（退单）并通知仓储物流部打印；</p>
            <p>2、仓储物流部打印销售单（退单）按照入库流程实现凭单入库，纸质怀远销售单同《到达客户配件退库单》（三联）按照销售单流传路径当天将反馈到中心库及“退库对接人”处；</p>
            <p>3、针对退库争议配件请示品牌总监处理，特殊情况上报配件公司；</p>
            <p><strong>该流程规定自通知公布即开始实时，操作过程中不合适可以优化，对不履行规定部门将月度考核事业部第一责权人100分/每单；</strong></p>
            <br/>
            <img src={tuihuodan641} alt="" style={{  width  : '50%', display: 'block', margin : '0 auto'}}/>
            <img src={tuihuodan642} alt="" style={{ width  : '50%', display: 'block', margin : '0 auto',}}/>
            <br/>
            <h4>4.4.2 依据退库原因优化流程及标准，完善仓储管理，当天反馈到管理公司；</h4>
            <h4>4.5 关于备货时效、准确度每月完成一次竞技比赛，包含标准执行、单项备货时效、检验质量；前三名依次奖励500分、300分、200分。</h4>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4 name="0-5-1-3-1-4" className="point" id="0-5-1-3-1-4">5. 新员工入职</h4>
            <p>不分岗位必须完成在仓储物流部见习2个月，熟悉仓储流程、专业知识；无仓储部出具见习报告无法完成转正。</p>
            <br/>
            <h4 name="0-5-1-3-1-5" className="point" id="0-5-1-3-1-5">6. 培训</h4>
            <p>6.1 非仓储物流人员每月有一天仓储物流部实践，实践收获以书面形式上报事业部总监，统计部备案，（仓储物流部有针对性安排实践并做评价）激励100分。</p>
            <p>6.2 管理公司各部室关于整车结构、总成结构结合云豪学院制定培训计划。</p>
            <p>未按规定执行对应负责人考核100分。</p>
            <br/>
            <h4 name="0-5-1-3-1-6" className="point" id="0-5-1-3-1-6">7. 网络营销</h4>
            <p>7.1独立微信号：产品信息、成交信息、提示信息，销售人员销售过程中鼓励客户添加朋友，通过该微信号将上述信息发布到自己朋友圈（不拉群、不骚扰、只做自己朋友圈宣传）。视添加情况每添加一人激励10分。</p>
            <p>责任部门：配件营销事业部对应责任人</p>
            <p>7.2独立公众号：宣传、配件商城、实现分销功能（区域代理）；</p>
            <p>责任部门：中心库对应责任人</p>
            <h4 name="0-5-1-3-1-7" className="point" id="0-5-1-3-1-7">8. 市场部作业流程及标准</h4>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure612' title="《市场部作业流程及标准》" onClick={(value)=>this.showDrawer(value)}>《市场部作业流程及标准》</a></div>
            <h4 name="0-5-1-3-1-8" className="point" id="0-5-1-3-1-8">9. 销售支持科业务流程及标准</h4>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure613' title="《销售支持科业务流程及标准》" onClick={(value)=>this.showDrawer(value)}>《销售支持科业务流程及标准》</a></div>
            <br/>
            <div><strong style={{color:'#6699FF'}}>10.附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure631' title="《销售政策（价格）制定流程》" onClick={(value)=>this.showDrawer(value)}>《销售政策（价格）制定流程》</a></div>
            <div><strong style={{color:'#6699FF'}}>11.附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure632' title="《信誉资金、临时授信投放流程》" onClick={(value)=>this.showDrawer(value)}>《信誉资金、临时授信投放流程》</a></div>
            <div><strong style={{color:'#6699FF'}}>12.附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure633' title="《续签月结合同签订流程》" onClick={(value)=>this.showDrawer(value)}>《续签月结合同签订流程》</a></div>
            <div><strong style={{color:'#6699FF'}}>13.附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure634' title="《备品销售政策》" onClick={(value)=>this.showDrawer(value)}>《备品销售政策》</a></div>
            
            <br/>
        </div>
    </div>
        <h4 name="0-5-1-3-2" className="point" id="0-5-1-3-2">4.3 配件营销绩效方案细则</h4>
        {/* <br/>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure65' title="《配件营销绩效方案细则》" onClick={(value)=>this.showDrawer(value)}>《配件营销绩效方案细则》</a></div>
        <br/> */}
        <div style={{ textIndent: '2em' }}>
            <h3></h3>
            <p>2020年为更加合理利用集团公司人力资源、客户资源、品牌资源，配件业务管理公司特制定配件《全员配件营销季度激励管理办法》，具体细则如下：</p>
            <h4>一、实施时间：</h4>
            <p>2020年1月1日起</p>
            <h4>二、兑现单位及实施对象：</h4>
            <p>1、配件营销激励由品牌事业部统计并报管理公司审核后上报集团公司财务部审批，因奖励所产生的费用全部计算在配件管理公司成本中。</p>
            <p>2、全集团公司非专职配件营销岗位及总经理以下岗位（含总经理）和客户直销。</p>
            <h4>三、非专职营销岗位定义：</h4>
            <p>1、不在配件业务管理公司担任职务的人员</p>
            <p>2、集团公司其他营销机构不用配件销量考核或计算绩效的人员</p>
            <p>3、在集团公司担任配件营销工作但和配件业务管理公司经营品牌不重叠的人员。</p>
            <h4>四、奖励细则：</h4>
            <br/>
            <img src={jianglixize651} alt="" style={{
                width  : '60%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>说明:</p>
            <p>1、提供的信息，经配件业务管理公司专人核实后真实有效且非在售客户（半年内）和客户的下游渠道。</p>
            <p>2、所有奖励均为动态积分奖励增加至次月当事人的动态积分中。（悦积分）</p>
            <p>3、个人直接销售的根据金额按照配件业务员管理公司营销专员绩效发放在次月兑现，不再增加动态积分。</p>
            <p>4、额外激励：季度信息提供第一名奖励300分，下月度兑现。</p>
            <p>5、额外激励：季度配件品牌事业部接收信息第一名奖励200分，下月度兑现。</p>
            <p>6、人员招聘：通过自行主动招聘、介绍或转介绍任职成功的人员，奖励动态积分100/次</p>
            <p>7、市场部新客户季度销售额20万元及以上或季度增长率为30%及以上客户，经验分享，激励动态积
分200分/次</p>
            <h4>五、考核：</h4>
            <p>1、配件营销事业部所有人员都有接收和核实信息的责任，并由接收人对信息核实，必须给予信息提供者回复然后以书面形式报事业部统计科存档。</p>
            <p>2、对于拒绝接收信息的负激励500分/次，累计2次以上的按照集团公司员工手册严重违纪处理。</p>
            <p>3、配件品牌事业部人员收到信息不作为、不回复、不报统计科的负激励500分/次，季度累计3次以上的按照集团公司员工手册严重违纪处理。</p>
            <p>4、配件品牌事业部统计科相关人员漏统计100分/次，季度累计3次以上扣除下月度全部绩效。</p>
            <p>5、集团公司任何人员未经品牌负责人允许，不得低价销售，为了获取信息报价或直销时对已在售客户和下游渠道未经允许，低于原销售政策时负激励500分/次，并上报集团公司监察部追究后续责任。</p>
            <p>6、市场部人员鱼池客户数据分析及行动计划上报市场部总监，日汇报、周汇报、月汇报，不报者负激励200元/次</p>
            <h4>六、异议监督投诉受理人：</h4>
            <br/>
            <img src={tousushouliren652} alt="" style={{
                width  : '60%',
                display: 'block',
                margin : '0 auto'
            }}/>
            <br/>
            <p>注：或直接向集团公司监察部投诉</p>
            <br/><br/>
        </div>

        <br/>
        <h3 name="0-5-1-4" className="point" id="0-5-1-4">2021年云豪集团中汽北消装备公司组织机构图及管理层人事安排</h3>
        <img src={zhizao11} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
        <h4 name="0-5-1-4-0" className="point" id="0-5-1-4-0"> 一、中汽北消装备公司支持监管机构管理层人事安排： </h4>
    
        <h4></h4>
        <p><strong>1、总经理：</strong>刘革，全面负责公司人、财、物、产、供、销，为中汽北消第一责权人，向董事长汇报工作。</p>
        <p><strong>2、党支部书记：</strong>孟小英，主管老北消人事工作，负责老北消档案整理，对总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>3、副总经理：</strong>陈旭（三级总监)，主管营销事业部，针对公司业务工作向总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>4、副总经理：</strong>王云祥（二级总监)，主管生产制造部，向总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>5、总工程师：</strong>杨俊佰，负责公司的技术开发、工艺、工装、工时标准体系建设；监管技术部，向总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>6、行政部 负责人：</strong>李慧媛（兼），向总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>7、财务部 总监：</strong>郝惠东（兼）</p>
        <p>财务专员 ：王婷 （兼）</p>
        <p><strong>8、综合管理部 部长:</strong>梁志慧（副总监主持工作)，全面负责本部门的工作，主管 公司产品的产品认证、资质认证、行业管理机构对接、市场信息的采集、订单接收、对外协作联络，向总经理汇报工作，服从上级领导的工作安排。</p>
        <p><strong>9、专家委员会</strong></p>
        <p>赵志国 （专家），主要工作配合企业的产品及资质认证工作；</p>
        <p>佟建紅 （专家），主要工作配合企业质检及生产业务。</p>
        <h3>二、营销事业部 </h3>
        <p><strong>总监：</strong>陈旭（兼），全面负责营销部工作，对总经理汇报工作，服从上级领导的工作安排。</p>
        <h3>三、生产制造部</h3>
        <p>1、总监：王云祥（兼)</p>
        <p>2、车间主任：刘晓兵（科级)</p>
        <p>车间副主任：刘鸿元（副科级)，对主任汇报工作，服从上级领导的工作安排。</p>
        <p>3、质检科 负责人：李敏，对总监汇报工作，服从上级领导的工作安排。</p>
        <p>4、设备科 负责人:刘晓兵（兼)，向总监汇报工作，服从上级领导的工作安排。</p>
        <h3>四、技术开发部</h3>
        <p>1、总监:张少俊（一级)，全面负责技术部所属各项工作，对总经理汇报工作，服从上级领导的工作安排。</p>
        <p>2、工艺科 </p>
        <p>负责人:张少俊（兼），对技术总监汇报工作，服从上级领导的工作安排。</p>
        <p>3、设计科  </p>
        <p>负责人:张少俊（兼），对技术总监汇报工作，服从上级领导的工作安排。</p>
        <h3>五、采购部</h3>
        <p>1、总监:刘革（兼)</p>
        <p>副总监：刘显荣，全面负责公司的采购工作，向总监汇报工作，服从上级领导的工作安排。</p>
        <p>2、仓储物流科</p>
        <p>负责人:李敏（兼），负责公司产品所需物资的储存与配送业务，向分管副总监汇报工作，服从上级领导的工作安排。</p>
        <p>3、国内采购科</p>
        <p>负责人: 刘显荣（兼），负责公司产品中国产部件及物资的采购工作，向总监汇报工作，服从上级领导的工作安排。</p>
        <p>4、进口采购科</p>
        <p>科长:李惠媛（科级），负责公司产品中需进口的部件及物资的采购工作，向分管副总监汇报工作，服从上级领导的工作安排。</p>

        <br/>
        <h3 name="0-5-1-5" className="point" id="0-5-1-5">6、海外业务管理公司内部管控细则</h3>
        <h3 name="0-5-1-5-0" className="point" id="0-5-1-5-0">第一部分 2021年海外业务管理公司组织机构图及人事安排</h3>
        <h4>一、海外业务管理公司组织机构图</h4>
        <img src={haiwai11} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <h4>二、海外业务管理公司人事安排：</h4>
        <p><strong>1、总经理：</strong>王云厅（兼）</p>
        <p><strong>2、副总经理：</strong>范晓瑞（二级总监），全面负责该管理公司人、财、物、产、供、销，为该管理公司的第一责权人； </p>
        <p>负责支持和监管集团公司海外基地（尼日利亚亚非国际、埃塞 E TRUCK、沙特NOR MOTORS、迪拜NOR MOTORS、泰国公司 ）；负责海外市场的新车、二手车、配件出口业务的拓展营销；向总经理汇报工作。</p>
    
        <h4>3、单证部：</h4>
        <p>职能：负责支持集团本部和海外基地（尼日利亚亚非国际、埃塞 E TRUCK、沙特NOR MOTORS、迪拜NOR MOTORS、泰国公司 ）的出口发运整个贸易流程的操作、跟踪，费用预算和成本控制：</p>
        <p>负责人：王建（副总监），主管配件科，监管整车科；向副总经理汇报工作；服从上级领导工作安排。</p>
        <div style={{textIndent: '2em'}}>
            <p>整车科：王倩</p>
            <p>配件科：王建（兼）</p>
            <h4>4、审计部：</h4>
            <p>职能：负责集团公司本部业务开展项目进度、成本、风险、台账、数据准确性、应收账款等财务统计工作的执行把控；</p>
            <p>负责统计审计海外公司（尼日利亚亚非国际、埃塞 E TRUCK、沙特NOR MOTORS、迪拜NOR MOTORS、泰国公司 ）生产生活物资、整车和配件库存、资金、财务制度、财务预算等的执行情况；向集团公司财务部及副经理汇报；</p>
        </div>
        <p><strong>负责人：</strong>王倩（科级），向副总经理汇报工作；服从上级领导工作安排。</p>
        <h4>5、办公室：</h4>
        <p>职能：负责管理公司人员招聘、职业规划、员工关怀，落实量化部门员工业绩考核完成情况；负责支持监管海外驻外员工的招聘、职业规划、员工关怀以及集团规章制度的执行情况；负责管理运营管理公司信息化业务；对接集团人力资源部和办公室工作；向副总经理汇报工作，服从上级领导工作安排；</p>
        <p>负责人：待定。</p>
        <h4>6、营销事业部</h4>
        <p>职能：负责海外市场的新车、二手车、配件出口业务的拓展营销；</p>
        <p>负责人：范晓瑞（兼）。</p>
        <h4>7、二手车事业部</h4>
        <p>职能：负责二手车业务整个流程的操作、跟踪，业务标准制定和执行、费用预算和成本控制，涵盖二手车收车、整备、进展、二手车零部件等业务。向副总经理汇报工作，服从上级领导工作安排；</p>
        <p>负责人：冯燕飞（三级总监），向副总经理汇报工作，服从上级领导工作安排。</p>

        <h3 name="0-5-1-5-1" className="point" id="0-5-1-5-1">第二部分 海外业务管理公司各部门职能</h3>
        <h4>一、行政部部门职能：</h4>
        <p>1.贯彻集团公司各项方针、制度、指令，负责监督、协调、检查部门的实施情况。</p>
        <p>2.负责海外公司本部及海外公司人力资源管理（对接集团人力资源部办理招/入/转/调/离手续及存档备案，出国人员接送机/签证/疫苗/海外险增减等办理）。 </p>
        <p>3.负责准备海外公司本部各项例会及业务会议，起草会议文件、会后整理会议纪要，及时下发。</p>
        <p>4.负责海外公司本部行政类文件起草、下达、管理。</p>
        <h4>二、统计部部门职能：</h4>
        <p>分管云湖春煜（天津）资产管理有限公司统计科</p>
        <p>1.根据集团公司及行业管理要求编制有关报表格式、原始记录表，报部门经理审批，并负责组建海外公司业务统计系统。</p>
        <p>2.月末汇总部门的各项统计数据并制作报表，提报总经理审批，（费用、业务、晨/周会纪要及参会人数）。</p>
        <p>3.负责对部门统计报表的真实性进行复核。对报出的各种统计数据的真实性、准确性、及时性负主要责任。经部门总经理审核无误后，上报集团公司相关部门有关统计数据及资料。</p>
        <p>4.根据集团财务部、审计部要求，填制并及时报送统计报表。</p>
        <p>5.制定并完善统计工作管理制度，负责各相关统计管理责任，健全原始记录、统计台账及报表制度。</p>
        <p>6.按规定归档保管各种统计资料及文件。</p>
        <h4>三、单证部部门职能：</h4>
        <p>1.负责海外公司管理公司各种单据的申请和制作，信用证的审证议付等工作；</p>
        <p>2.负责整个贸易流程的操作、跟踪，费用预算和成本控制，收款和退税；</p>
        <p>3.负责贸易流程中可能产生的风险管控；</p>
        <p>4.负责完善产品和运输等询价报价体系；</p>
        <p>5.负责修改和完善本部门工作流程和各项规章制度；</p>
        <p>6.负责对本部所属员工进行外贸知识培训；</p>
        <p>7.配合和支持其它相关部门的工作；</p>
        <h3 name="0-5-1-5-2" className="point" id="0-5-1-5-2">第三部分 海外业务管理公司内部管控细则</h3>
        <h4>(一)目的</h4>
        <p>明确海外业务管理公司工作流程及标准，确保本部人员及海外分公司人员遵守集团公司规章制度及流程秩序，强化各流程工作执行能力，确保国内外人员能够各司其职、协调配合，以提升整体工作效益。</p>
        <h4>(二)范围</h4>
        <p>本部分工作流程适用于云豪集团海外业务管理公司本部及海外分公司人员，应用于考勤管理、周月报管理、费用报销管理、人员管理、人员培训、会议细则、后勤保障和台账管理等工作领域。</p>
        <h4>(三)管理细则</h4>
        <p><strong>1.考勤管理细则</strong> 依照集团公司考勤管理细则执行</p>
        <p><strong>2.周/月报管理细则</strong></p>
        <p>2.1 海外业务管理公司本部人员：依照集团公司规定作业管理细则执行</p>
        <p>2.2海外分公司人员依照附件《海外分公司三会三报管理细则》执行</p>
        <div><strong style={{color:'#6699FF'}}>附件1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure626' title="《海外分公司三会三报管理细则》" onClick={(value)=>this.showDrawer(value)}>《海外分公司三会三报管理细则》</a></div>
        <p><strong>3.费用报销管理细则</strong> 依照集团公司费用报销制度及审批流程</p>
        <h4>4.人员管理细则</h4>
        <p>依据海外公司管理公司及海外分公司的业务发展规划，加强团队建设，与集团人力资源部做好衔接工作，确保国内及海外分公司人员招聘、离职、调岗、晋升、回国、出国等方面的人事工作顺利进行，建立详尽准确的人员管理档案记录。</p>
        <p>另附《关于海外公司驻外人员管理制度》、《驻外人员派遣协议书》、《驻外回调申请表》、《海外人员需求表》作为海外业务管理公司海外分公司人员管理制度补充细则。   </p>

        <div><strong style={{color:'#6699FF'}}>附件1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure624' title="《海外公司驻外人员管理制度》" onClick={(value)=>this.showDrawer(value)}>《海外公司驻外人员管理制度》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件2：</strong><a href="javascript:void(0);" type="primary" id='Enclosure625' title="《驻外人员派遣协议书》" onClick={(value)=>this.showDrawer(value)}>《云豪集团驻外人员派遣协议书》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件3：</strong><a href="javascript:void(0);" type="primary" id='Enclosure622' title="《驻外回调申请表》" onClick={(value)=>this.showDrawer(value)}>《海外公司驻外员工回调申请表》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件4：</strong><a href="javascript:void(0);" type="primary" id='Enclosure623' title="《海外人员需求表》" onClick={(value)=>this.showDrawer(value)}>《海外人员需求表》</a></div>

        <h4>国内人员管理流程如下:</h4>
        <img src={haiwaifengongsirenyuanguanli} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
        <h4>海外分公司人员管理流程如下：</h4>
        <h4>回国人员管理流程</h4>
        <img src={haiwaifengongsirenyuanguanli1} alt="" style={{ width  : '800px', display: 'block', margin : '0 auto' }}/>
        <h4>出国人员管理流程</h4>
        <img src={haiwaifengongsirenyuanguanli2} alt="" style={{ width  : '800px', display: 'block', margin : '0 auto' }}/>
        <h4>5.人员培训细则</h4>
         <p>按照集团公司的培训计划，海外业务管理公司组织相关人员及时参加集团的各项培训活动，如新员工培训、总裁见面会、云豪精英训练营、云豪学院各项培训课程等。</p>
         <p>海外业务管理公司组织制定切实可行的内部培训计划并定期组织培训活动，如英语培训、外贸培训、办公软件操作培训、招投标培训、汽车专业知识培训等，充分发挥员工的专长，提升团队整体综合素质。</p>
        <h4>6.会议细则</h4>
        <p>依照集团公司月会周会晨夕会管理细则执行。</p>
        <h4>7.后勤保障细则</h4>
        <p>行政部负责海外公司管理公司本部及海外分公司的后勤保障工作，做好与集团各部门的衔接，在办公用品申领、资产物资管理、订购车票机票酒店、招待住宿调车等方面给予协调处理，及时有效地保障各项工作顺利进行。</p>
        <p>后勤保障流程如下：</p>
        <img src={houqinbaozhangliucheng} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
        <h4>8.台账管理细则</h4>
        <p>统计部负责建立健全的统计台帐。统计台帐应按统一格式，台帐主要指标设置应与统计调查报表制度一致，具备连续性、实用性和稳定性。负责记录整车销售、配件销售台账，统计每月、每季度、每年的应收账款。收集每笔出口业务的所有单据，例如：外贸合同、采购合同、信用证等（包括电子版和纸质版）</p>
        <h4>台账管理细则如下</h4>
        <img src={taizhangguanli} alt="" style={{ width  : '700px', display: 'block', margin : '0 auto' }}/>
        <h3 name="0-5-1-5-3" className="point" id="0-5-1-5-3">第四部分 海外公司各部门业务流程细则</h3>
        <h4>一、统计部工作流程细则</h4>
        <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure614' title="《海外业务管理公司统计部业务流程》" onClick={(value)=>this.showDrawer(value)}>《海外业务管理公司统计部业务流程》</a></div>
        <br/>
        <h4>二、单证部工作流程细则</h4>
        <div><strong style={{color:'#6699FF'}}>附件1：</strong><a href="javascript:void(0);" type="primary" id='Enclosure615' title="《海外业务管理公司整车业务流程》" onClick={(value)=>this.showDrawer(value)}>《海外业务管理公司整车业务流程》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件2：</strong><a href="javascript:void(0);" type="primary" id='Enclosure616' title="《海外业务管理公司上装业务流程》" onClick={(value)=>this.showDrawer(value)}>《海外业务管理公司上装业务流程》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件3：</strong><a href="javascript:void(0);" type="primary" id='Enclosure617' title="《二手车事业部二手车业务流程》" onClick={(value)=>this.showDrawer(value)}>《二手车事业部二手车业务流程》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件4：</strong><a href="javascript:void(0);" type="primary" id='Enclosure618' title="《贸促会注册、产地证申领流程》" onClick={(value)=>this.showDrawer(value)}>《贸促会注册、产地证申领流程》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件5：</strong><a href="javascript:void(0);" type="primary" id='Enclosure619' title="《尼日利亚PC办理流程》" onClick={(value)=>this.showDrawer(value)}>《尼日利亚PC办理流程》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件6：</strong><a href="javascript:void(0);" type="primary" id='Enclosure620' title="《2020年云豪备品出口业务流程及相关岗位职责》" onClick={(value)=>this.showDrawer(value)}>《2020年云豪备品出口业务流程及相关岗位职责》</a></div>
        <div><strong style={{color:'#6699FF'}}>附件7：</strong><a href="javascript:void(0);" type="primary" id='Enclosure621' title="《海外业务管理公司外贸业务流程细则》" onClick={(value)=>this.showDrawer(value)}>《海外业务管理公司外贸业务流程细则》</a></div>

        <br/>
        <h3 name="0-5-1-6" className="point" id="0-5-1-6">7、电商中心</h3>
        <h3 name="0-5-1-6-0" className="point" id="0-5-1-6-0">电商中心组织机构图及人事安排</h3>
        <h3 >一、电商中心组织机构图</h3>
        <img src={dianshang11} alt="" style={{width  : '600px',display: 'block',margin : '0 auto'}}/> 
        <h4> 二、电商中心职能</h4>
        <p>1、协助集团公司、各分公司及业务单位管理功能；（系统管理）</p>
        <p>2、全集团公司财务全流程参与把控：花钱与收款；（进、销、存）</p>
        <p>3、全公司内部物联网；物品赋能，每个物品呈现各种信息状态，快速找到需要的货品；</p>
        <p>4、根据各业务公司的不同业务需求定制开发业务流程，提高办公效率；（细分、优化、简化操作流程）</p>
        <p>5、规范各项标准制定系统上实施及监督实施过程；（统一配件基础档案、统一维修项目及工时标准、</p>
        <p>统一客户信息管理标准，使各种数据以少积多数据中心真正能起到作用）</p>
        <p>6、集团公司鱼池建设及共享做技术支持；</p>
        <p>7、创业空间、微老板实施做管理及技术支持；</p>
        <p>8、实现线上交易、支付、宣传做支持；</p>
        <p>9、实现商用车产业链平台运营商做技术支持；</p>
        <p>10、集团公司信息化优化、完善、升级；</p>
        <p></p>

        <h4>三、电商中心人事安排</h4>
        <p><strong>1、总经理：</strong>李栋卫，全面负责该中心人、财、物、产、供、销，为该中心的第一责权人，负责集团公司信息化建设（集团公司ERP产品把控、项目把控、技术把控）及企业线上宣传；向集团公司董事长汇报工作。</p>
        <p><strong>2、副总经理：</strong>王佳林，电商中心第二责权人，负责IT技术全面工作（ CTO ），向总经理汇报工作，服从上级领导工作安排。 </p>
        <h4>3、技术部：</h4>    
        <p>职能：负责规划公司信息化技术框架、技术路线、技术预研，集团公司技术官（ CTO ）；集团公司网络运维，企业运维、服务器运维及网站运维；</p>
        <p>负责人：王佳林（兼）向主管技术副总经理汇报工作；服从上级领导工作安排。</p>
        <h4>4、项目部开发部：</h4>
        <p>职能：负责集团公司信息化建设过程中涉及到的项目范围、进度、质量、成本、相关方、风险、沟通、变更等相关工作的把控，按接到的产品画像进行开发，负责项目成果的生成； </p>
        <p><strong>总监 ：</strong>张臣（一级）向电商中心总经理汇报工作；项目部第一责权人，服从上级领导工作安排。 </p>
        <h4>5、产品运营部：</h4>
        <p>职能：负责规划、设计集团公司信息化建设过程中涉及到的产品调研、需求、规划、设计、测试、迭代升级、维护、售后等相关工作的把控，集团官网网上宣传、支持各业务部门相关的宣传工作；</p>
        <p>负责人：王佳林（兼）向电商中心总经理汇报工作；服从上级领导工作安排。</p>
        <p><strong>6、统计部 </strong>负责人：张晓莹（科级），管理监督电商中心统计工作，统计管理各网站咨询数据；统计工作向总经理汇报，产品工作向CTO 汇报；服从上级领导工作安排。</p>
       
        <br/>
        <h3 name="0-5-1-6-1" className="point" id="0-5-1-6-1"> 电商中心2020年任务指标</h3>
        <p>1、一个系统（ERP系统），集团公司统一使用一个系统（ERP系统）； </p>
        <p>2、两个网站（云豪车服、老年车网站），两个功能模块优化、升级；（维修、配件）</p>
        <p>3、完成3个功能模块，创业空间、外贸、拆车及再制造模块开发；</p>
        <p>4、四个标准实施，（配件基础档案统一标准、维修项目统一命名、维修工时统一标准、客户基础档案统一录入格式，目的：提炼数据对二手车回收及车队承包维修提供理论依据）</p>
        <p>5、五个基地弱电安全，保障办公需求；（办公设备、网络安全、服务器管理、监控设备等） </p>
        <p>6、六块大屏；延庆、大兴基地动态信息屏及各基地、仓储业务信息屏； </p>
        <p>7、七个网站，（陕汽、潍柴、WABCO、斯堪尼亚、依维柯、红岩、綦齿） </p>
        
        <h3 name="0-5-1-6-2" className="point" id="0-5-1-6-2"> 电商中心内部管控流程及执行标准</h3>
        <h4 name="0-5-1-6-2-0" className="point" id="0-5-1-6-2-0">一、电商中心统计部</h4>
        <p><strong>1、业务范围：</strong></p>
        <p>1.1完成电商中心各项数据统计，</p>
        <p>1.2数据整理上报并存档；</p>
        <p>1.3系统测试及培训；</p>
        <h4>2、岗位职责：</h4>
        <p>2.1统计网络推广公司相关数据，并编制统计日报表，作为数据的来源，统计人员要保证所提供数据的准确性。</p>
        <p>2.2系统培训教材、视频教材及系统使用说明书的编写。</p>
        <p>2.3对集团公司员工系统使用培训。</p>
        <p>2.4统计客服数据；</p>
        <p>2.5报表确认无误后由制表人，审核人，事业部负责人签字。</p>

        <h4 name="0-5-1-6-2-1" className="point" id="0-5-1-6-2-1">二、电商中心技术部</h4>
        <p><strong>1、业务范围：</strong></p>
        <p>1.1负责电商中心内部人员技术培训；</p>
        <p>1.2培资料的准备及培训后培训教材、资料整理归档；</p>
        <p>1.3集团公司信息化建设架构设定，信息化建设技术参数规范；</p>
        <p>1.4承担集团公司CTO角色；</p>
        <p>1.52020年度公司信息化项目开发及实施的进度、质量和成本控制；</p>
        <h4>2、技术部专项培训规范</h4>
        <p>由张臣与云豪学院对接专项培训，由云豪学院颁发相关证书并给予积分奖励。</p>
        <p>2.1培训对象</p>
        <p>本电商中心IT人员、信息化部、各营销公司与网络营销相对接的IT人员，以及云豪集团有意愿学习IT知识的人员。</p>
        <p>2.2培训时间及频率</p>
        <p>培训时间：每月至少2次，月初1次，月中1次；</p>
        <p>2.3.1程序开发技术使用课程；</p>
        <p>2.3.2技术标准规范课程；</p>
        <p>2.3.3 计算机技术</p>
        <p>2.3.4 Photoshop图片处理课程</p>
        <p>2.3.5 UI设计课程</p>
        <p>2.3.6前端框架培训</p>
        <p>2.3.7 HTML、CSS、JS网页制作培训</p>
        <p>2.3.8 PHP、Java框架讲解</p>
        <p>2.3.9 Python语言讲解</p>
        <p>以上培训内容的积分考核以云豪学院颁布的标准为依据。</p>
        
        <h4 name="0-5-1-6-2-2" className="point" id="0-5-1-6-2-2">三、网络营销事业部</h4>
        <p>负责人：宁方伟</p>
        <p><strong>1、业务范围：</strong></p>
        <p>1.1 负责集团公司各品牌网站推广维护工作；</p>
        <p>1.2 负责集团公司新网站的开发建设工作；</p>
        <p>1.3 负责网络客户订单的处理；客户信息的手机；</p>
        <p>1.4 负责ERP需求调研工作；</p>
        <p>1.5 负责ERP测试工作；</p>
        <p>1.6 负责ERP培训工作；</p>
        <p>1.7 负责ERP产品销售。</p>
        <h4>2、业务流程</h4>
        <p>2.1卡车、客车网站维护流程</p>
        <img src={wangzhangweihuliucheng} alt="" style={{ width  : '600px', display: 'block',margin : '0 auto' }}/>
        <p><strong>具体操作细则</strong></p>
        <h4>说明（试用版）：</h4>
        <p>1、日常维护各自负责的网站正常运行。</p>
        <p>2、根据公司最新新闻事件网站资料数据当天更改为最新内容，最迟不得晚于24小时，保持原创性。</p>
        <p>3、文章内容必须审核后再发送，不得使用网上下载过来的图片，不得使用广告中禁用的词汇。</p>
        <h4>执行标准：</h4>
        <p>1、每周日常维护网站更新内容一篇，达到要求当月奖励80分。</p>
        <p>2、网站内容如出现违规侵权等事项，内部发现一列考核200分；如被举报被罚款，根据罚款金额个人承担一定的比例。</p>
        <h4>2.2、网站开发流程</h4>
        <h4>2.2.1内部开发</h4>
        <p>1、由副总监与各部门总监进行调研需求，并根据需求制作原型图与需求方进行演示确认需求签字后方可进行开发。</p>
        <p>2、由副总监根据网站需求制定出开发需求文档。</p>
        <p>3、提交需求文档与原型图给孵化部进行开发，确定开发周期给予用户进行反馈</p>
        <h4>2.2.2内部开发标准</h4>
        <p>1、网络部进步审核是否符合需求文档的功能需求。</p>
        <p>2、使用方进行验收，如不合格返回孵化部进行修改。</p>
        <p>3、后台功能不得超过5处BUG。一项不合格项目小组每个人扣30分/项，同样的错误再次出现扣60分/项;延时完成，扣100分/项/天；提前完成奖励100分/项/天。</p>
        <p>4、需求方如有流程变化需提交需求变更表，然后由项目组评估出在原有的版本中是否有推翻重做的风险，一旦确认风险过大在与需求方进行商谈或由云豪车服承担由风险造成的各项成本。</p>
        <h4>2.2.3外部开发</h4>
        <p>①找外援团队进行网站开发。</p>
        <p>②配合外部团队开发进行需求梳理及制作原型图。</p>
        <p>③开发完毕后由网络营销事业部进行初步验收并测试。</p>
        <p>④由需求方进行上线使用，有问题反馈给外援团队进行解决。</p>
        <p>1、由副总监与各部门总监进行调研需求，并根据需求制作原型图与配件公司负责人进行演示确认需求后再进行开发。</p>
        <p>2、由副总监根据网站需求制定出开发需求文档。</p>
        <p>3、提交需求文档与原型图给孵化部进行开发，确定开发周期给予需求方进行反馈</p>
        <h4>2.2.4验收标准</h4>
        <p>1、以需求文档为依据，满足需求文档的功能点。。</p>
        <p>2、保障网站源码可进行二次开发，可拓展性。</p>
        <p>3、无bug，运行稳定，网站打开响应速度不得高于5秒。</p>
        <p>4、必须提供售后保障。</p>
        <h4>2.3客服操作流程</h4> 
        <p>2.3.1 业务范围：</p>
        <p>2.3.1.1 接听400客户来电，区分客户需求，登记客户信息。</p>
        <p>2.3.1.2 根据客户需求能满足的直接销售。</p>
        <p>2.3.1.3 不能满足客户需求的客户信息转接至各营销机构相关人员。</p>
        <p>2.3.1.4 转接的客户电话要求跟踪是否成交，成交的客户登记备案，未成交的登记未成交原因。</p>
        <p>2.3.1.5 每月25日前汇总客户询盘数据发送至副总监微信或邮箱。</p>
        <p>2.3.2业务流程：</p>
        <img src={kefucaozuoliucheng} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
        <p>2.3.3 客户信息营销公司流程具体操作细则说明</p>
        <p>2.3.3.1 网络客户咨询。</p>
        <p>2.3.3.2 根据客户来源来区分客户类型（座机、400电话、手机、QQ、微信、百度商桥）</p>
        <p>2.3.3.3 客服人员接到客户咨询询问客户需求并登记客户信息及需求（需求：客户需要购买配件、维</p>
        <p>修咨询，整车业务咨询，所咨询的品牌；客户信息：联系人，联系方式，所属地区）</p>
        <p>2.3.3.4 无效信息是指客户咨询的业务非公司业务范围内（如：推广电话等），委婉拒绝，无效信息不做登记。</p>
        <p>2.3.3.5 有效客户信息可直接销售，从其他营销机构调拨配件实现独立销售。</p>
        <p>2.3.3.6 跟进售后服务是指收款，物流发货，确认客户签收，售后保障。</p>
        <p>2.3.3.7 不可直接销售的客户信息转至各营销机构对接人（要求：在15分钟内给客户回复，并在当天反馈客户咨询情况给客服）</p>
        <p>2.3.3.8客服与营销机构对接人跟进咨询进度(客户是否成交，未成交原因)</p>
        <p>2.3.3.9由客服完善有效客户信息（客户所在区域，维修厂/车队/个人，车辆信息等）	</p>
        <h4>2.4 ERP使用培训流程</h4>
        <img src={erpshiyongpeixunliucheng} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/>
        <h4>2.4.1考核标准</h4>
        <p>2.4.1.1 以参加培训人员进行考试，合格率超过80%来评定培训效果为合格给予单次考核200分。</p>
        <p>2.4.1.2 培训课件实用性不完整给予考核100分</p>
        <p>2.4.1.3 录制的培训视频通俗易懂，表达清晰考核100分</p>
        <p>2.5 ERP产品销售科流程：</p>
        <h4>2.6 ERP测试流程</h4>
        <img src={erpceshiliucheng} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
        <h4>测试考核标准：</h4>
        <p>2.6.1 测试用例的质量，是否按照真实数据用例进行测试，未按照真实有效数据进行测试考核100分。</p>
        <p>2.6.2 bug的提交情况；以项目组认定的bug数量进行考核，每出现一次重大bug造成系统崩溃考核200分；影响系统使用（无法按照流程继续操作）考核100分；一般问题考核50分；需求建议不计入考核项。</p>
        <p>2.6.3 测试报告的质量；报告描述不清晰、问题截图不完整或者没有造成开发团队无法理解问题所在考核100分；</p>
        <h4>2.7 需求调研流程</h4>
        <img src={xuqiudiaoyanliucheng} alt="" style={{ width  : '600px', display: 'block', margin : '0 auto' }}/>
        <p>2.7.1 需求调研标准：调研需求方的业务流程及功能点，按照需求文档的标准规范进行编写，引导用户潜在需求与实际需求，按照角色绘制泳道图，最终以原型图的形式展现给用户，演示业务流程的操作及各页面的功能点，最终用户签字确认后需求调研结束，交于技术组进行开发。
未按时完成需求调研考核200分。</p>

        <h4 name="0-5-1-6-2-3" className="point" id="0-5-1-6-2-3">四、孵化项目部</h4>
        <h4>负责人：张臣</h4>
        <p><strong>1、业务范围：</strong></p>
        <p>新建网站、集团内部系统开发等未成熟的IT项目。</p>
        <p>1.1短期项目</p>
        <p>1.1.1云豪车服GPS项目+视频监控系统（由信息化部配合）</p>
        <p>1.1.2人力资源员工积分管理系统（由人力资源部配合）</p>
        <p>1.2长期项目（ERP开发）</p>
        <p>1.2.1云创空间</p>
        <p>1.2.2云采项目</p>
        <p>1.2.3云储项目</p>
        <p>1.2.4云修项目</p>
        <p>1.2.5沙特项目</p>
        <p>1.2.6云造项目</p>
        <p>1.2.7二手车项目</p>
        <p>1.2.8鉴权系统</p>
        <p>1.2.9门户系统</p>
        <p>1.2.10人力资源系统</p>
        <p>1.2.11财务管理系统</p>
        <p>1.2.12客户管理系统</p>
        <p><strong>2、网站建设：</strong></p>
        <p>2.1重卡配件网</p>
        <p>2.2老牛车网</p>
        <p>2.3云豪车服</p>
        <p>2.4外文网站建设</p>
        <p>外文网站开发、维护、推广</p>
        <p><strong>3、网站升级维护备份：</strong></p>
        <p>各品牌网站的升级、维护、备份</p>
        <p><strong>4、孵化项目开发流程：</strong></p>
        <p>开发流程示意图</p>
        <img src={fuhuaxiangmukaifaliucheng} alt="" style={{ width  : '500px', display: 'block', margin : '0 auto' }}/>
        <p>4.1项目开发</p>
        <p>4.1.1提出项目开发意向——正式文件文档类功能需求</p>
        <p>4.1.1.1确定项目类型（网站、大数据平台功能、小程序、微信端等）</p>
        <p>4.1.1.2确定开发周期</p>
        <p>4.1.1.3确定功能模块（想要实现什么功能）</p>
        <p>4.1.1.4确定开发环境（针对有特殊语言要求的用户）</p>
        <p>4.1.1.5确定数据库类型（针对有数据库特殊需求的用户）</p>
        <p>4.1.1.6确定开发金额</p>
        <p>4.1.2业务内涵</p>
        <p>4.1.2.1提出明确的项目类型</p>
        <p>4.1.2.2提出明确的开发时间</p>
        <p>4.1.2.3明确提出功能需求</p>
        <p>4.1.2.4提出特殊需求文档</p>
        <p>4.1.2.5按照项目等级标准确定金额</p>
        <p>4.1.3项目经理立项及产品经理对接需求</p>
        <p>4.1.3.1核实项目类型</p>
        <p>4.1.3.2确定准确的开发周期</p>
        <p>4.1.3.3确定项目难易级别（短期项目、中期项目、长期项目）</p>
        <p>4.1.3.4确定开发环境（针对有特殊语言要求的用户）</p>
        <p>4.1.3.5确定开发数据库类型（针对有数据库特殊需求的用户）</p>
        <p>4.1.3.6确定项目中所需资料（参考资料、文字说明、基础档案、项目相关的图片、视频等）</p>
        <p>4.1.3.7提出项目开发中可预见性最优方案供用户选择（例：本地服务器与阿里服务器续费问题）</p>
        <p>4.1.3.8确定项目组参与开发人员</p>
        <p>4.1.3.9确定项目组人员时间分配</p>
        <p>4.1.4项目经理技能要求：</p>
        <p>4.1.4.1熟练掌握项目类型特点提出明确的开发时间</p>
        <p>4.1.4.2能够掌握各类型项目开发周期</p>
        <p>4.1.4.3具备根据项目需求判断项目级别能力</p>
        <p>4.1.4.4熟悉各开发环境特点</p>
        <p>4.1.4.5熟悉各数据库类型特点</p>
        <p>4.1.4.6具备项目开发中各个环节所需资料，收集整理能力</p>
        <p>4.1.4.7熟悉项目开发各个环节特点，具备提供最优方案的能力</p>
        <p>4.1.4.8具备协调各个项目组人员调配和掌控时间节点的能力</p>
        <p>4.1.5孵化项目开发</p>
        <p>4.1.5.1进一步确定产品开发细节</p>
        <p>4.1.5.2原型图制作，并与项目需求方确认是否符合开发需求，需要项目需求方签字确认开发</p>
        <p>4.1.5.3如符合开发需求则对项目参与人员制定smart工作计划；如未符合需求则需求方提出修改建议，与技术组达成一致后，开始修改原型图直至需求方通过后进入到开发流程</p>
        <p>4.1.5.4按照制定的smart计划下发任务至所有参与人员</p>
        <p>4.1.6孵化项目各环节落地标准：</p>
        <p>4.1.6.1各个环节细化到每个操作步骤</p>
        <p>4.1.6.2原型图与功能需求的匹配程度达到90%以上</p>
        <p>4.1.6.3按照smart原则制定开发计划，有目标、有时间节点、可度量</p>
        <p>4.1.6.4审核标准严格按照需求方需求审核</p>
        <p>4.1.6.5让团队每一名参与人员都清晰了解自己工作量与时间节点</p>
        <p>4.1.7</p>
        <p>4.1.7.1 UI设计</p>
        <p>4.1.7.1.1独立完成产品各个界面的设计和制作</p>
        <p>4.1.7.1.2与产品配合，参与设计体验，对UI进行优化改进；分析监控流行产品设计趋势，研究目标用户审美倾向并优化现有产品</p>
        <p>4.1.7.1.3把控界面美术效果和用户交互体验，时刻和需求方有效沟通；配合运营及研发相关人员，细化产品设计，确保优质的界面表现</p>
        <p>4.1.7.1.4与需求方确认需求；如符合开发需求则进入到前端页面开发阶段；如未符合需求则需求方提出修改建议，与项目组达成一致后，开始修改页面直至需求方通过后进入到前端流程</p>
        <p>4.1.7.2 UI设计标准</p>
        <p>4.1.7.2.1 保证页面制作数量</p>
        <p>4.1.7.2.2保证页面设计内容严格按照原型设计</p>
        <p>4.1.7.2.3保证页面设计合理逻辑清晰</p>
        <p>4.1.7.3 前端开发+数据库设计</p>
        <p>4.1.7.3.1前端开发</p>
        <p>4.1.7.3.1.1根据ui设计图组织梳理代码(目录)结构</p>
        <p>4.1.7.3.1.2根据设计图实现web页面</p>
        <p>4.1.7.3.1.3根据业务流程完成交互逻辑</p>
        <p>4.1.7.3.1.4项目设计团队进行审核，如符合开发需求则进入到前后台交互阶段，如未符合需求则项目设计提出修改建议，与前端设计人员达成一致后，开始修改前端内容直至项目设计通过后进入到前后台交互阶段</p>
        <p>4.1.7.3.2前端开发落地标准</p>
        <p>4.1.7.3.2.1保证页面制作数量与原型图一致</p>
        <p>4.1.7.3.2.2保证页面编写内容严格按照原型设计</p>
        <p>4.1.7.3.2.3保证页面交互逻辑清晰合理</p>
        <p>4.1.7.3.2.4代码编写美观规范；严格按照行业标准编写</p>
        <p>4.1.7.3.2.5保证项目可遗传性</p>
        <p>4.1.7.4数据库设计</p>
        <p>4.1.7.4.1按照原型图功能模块梳理数据流程、数据库架构</p>
        <p>4.1.7.4.2数据表字段设计</p>
        <p>4.1.7.4.3数据表字段类型设计</p>
        <p>4.1.7.4.4形成数据库文档，与后台对接数据库验证可行性</p>
        <p>4.1.7.4.5如符合开发需求则进入到后台接口开发阶段；如未符合需求则项目设计提出修改建议，与数据库设计人员达成一致后，开始修改数据库内容直至后台人员通过后进入到后台开发流程</p>
        <p>4.1.7.5数据库落地标准</p>
        <p>4.1.7.5.1数据逻辑清晰，数据库整体架构逻辑清晰无误</p>
        <p>4.1.7.5.2数据库设计文档条理清晰无误</p>
        <p>4.1.7.5.3数据库命名要求符合行业标准</p>
        <p>4.1.7.5.4保证项目可遗传性</p>
        <p>4.1.7.6后台开发</p>
        <p>4.1.7.6.1根据原型系统完成后台接口功能</p>
        <p>4.1.7.6.2自检接口的质量</p>
        <p>4.1.7.6.3如自检合格则部署到服务器并运行；如为合格则自行修改至合格后部署到服务器运行</p>
        <p>4.1.7.6.4整理接口文档，交与前端</p>
        <p>4.1.7.7后台开发落地标准</p>
        <p>4.1.7.7.1代码编写简洁、美观，结构清晰，且注释齐全</p>
        <p>4.1.7.7.2接口文档清晰完整</p>
        <p>4.1.7.7.3接口一次性合格率80%</p>
        <p>4.1.7.7.4当日必须更新完成当日的接口文档</p>
        <p>4.1.7.7.5保证项目可遗传性</p>
        <p>4.1.8前后台交互设计</p>
        <p>4.1.8.1前端调试数据接口及完善交互逻辑</p>
        <p>4.1.8.2后台需配合前端人员调试接口</p>
        <p>4.1.8.3前端、后台需协同自检项目质量</p>
        <p>4.1.8.4如自检合格则进入到项目测试阶段，如自检未合格则自行修改至合格后进入到项目测试阶段</p>
        <p>4.1.9前后台交互设计标准</p>
        <p>4.1.9.1前台与后台如期实现预定功能</p>
        <p>4.1.9.2实现的功能符合设计功能</p>
        <p>4.1.10项目测试阶段+项目档案制作</p>
        <p>4.1.10.1项目测试</p>
        <p>4.1.10.1.1针对业务流程进行项目测试</p>
        <p>4.1.10.1.2针对数据流程进行项目测试</p>
        <p>4.1.10.1.3如项目测试合格则进入到验收阶段；如项目测试为合格，需出示文档说明交与项目设计，核定任务量、时间节点、修改人员并分配任务至修改无误后进入到验收阶段</p>
        <p>4.1.10.2项目测试标准：</p>
        <p>4.1.10.2.1测试项目业务流程、逻辑通顺</p>
        <p>4.1.10.2.2测试数据正常</p>
        <p>4.1.10.3项目档案制作</p>
        <p>4.1.10.3.1项目设计档案</p>
        <p>4.1.10.3.2数据库设计档案</p>
        <p>4.1.10.3.3后台接口档案</p>
        <p>4.1.10.3.4用户使用手册</p>
        <p>4.1.10.4项目档案制作标准：</p>
        <p>4.1.10.4.1所需文档资料内容覆盖率95%</p>
        <p>4.1.10.4.2所需文档资料齐全</p>
        <p>4.1.11项目试运行</p>
        <p>4.1.11.1确定试运行时间</p>
        <p>4.1.11.2如试运行期间内未出现问题，则试运行结束后进入到项目验收阶段；如试运行期间出现问题，则开发团队无条件进行修改；（项目已定需求外的需求除外）</p>
        <p>4.1.11.3项目试运行标准</p>
        <p>4.1.11.3.1项目试运行阶段，保证项目运行无报错率达到85%以上</p>
        <p>4.1.11.3.2项目试运行阶段，稳定性达到90%以上</p>
        <p>4.1.12项目验收</p>
        <p>4.1.12.1需求方、项目经理两方会议</p>
        <p>4.1.12.2如验收成功则进入到项目结款阶段；如有新需求则进入到二期开发阶段</p>
        <p>4.1.12.3项目验收标准</p>
        <p>4.1.12.3.1项目验收资料准备齐全</p>
        <p>4.1.12.3.2做好开发资料交接工作</p>
        <p>4.1.12.3.3 按合同技术要求验收</p>
        <p>4.1.13结款</p>
        <p>4.1.13.1按照约定款项结算费用,要有质保金</p>
        <p>4.1.14运维</p>
        <p>4.1.14.1保障项目运行环境正常</p>
        <p>4.1.14.2保障数据库运行正常、数据库备份</p>
        <p>4.1.14.3程序服务运行</p>
        <p>4.1.15运维标准：</p>
        <p>4.1.15.1保障项目运行环境稳定率达到95%</p>
        <p>4.1.15.2保障项目数据库备份率达到100%</p>
        <p>4.2项目考核</p>
        <p>  项目考核标准根据每个项目的任务量与时间具体分为以下几个部分组成</p>
        <p>4.2.1项目经理考核标准</p>
        <p>4.2.1.1熟练掌握项目类型特点提出明确的开发周期、确定数据库类型、开发环境、相关资源</p>
        <p>4.2.1.2能够运用项目经验制定出项目立项书，并组织项目立项会；全部完成可得100%，其余情况不得</p>
        <p>4.2.1.3项目实施过程中监控各类资源的动向，使资源得到最大化的运用，在质量、时间、成本三个方面得到最优组合；全部完成可得100%，质量、成本要求完成可得80%，质量要求完成可得50%</p>
        <p>4.2.2 UI设计考核标准</p>
        <p>4.2.2.1保证页面制作数量；数量全部完成得100%，80%完成得50%，50%以下不得</p>
        <p>4.2.2.2保证页面设计内容严格按照原型设计；完全还原内容得100%，其余不得</p>
        <p>4.2.2.3保证页面设计合理逻辑清晰；清晰合理得100%，其余不得</p>
        <p>4.2.3前端开发考核标准</p>
        <p>4.2.3.1保证页面制作数量与原型图一致；完全还原得100%，其余情况不得</p>
        <p>4.2.3.4代码编写美观规范；严格按照行业标准编写；美观规范得100%，规范不美观得70%，不规范不美观不得</p>
        <p>4.2.3.5保证项目可遗传性；全部保证得100%，其余不得</p>
        <p>4.2.4数据库考核标准</p>
        <p>4.2.4.1数据逻辑清晰，数据库整体架构逻辑清晰无误；数据逻辑清晰无误得100%，其余情况不得</p>
        <p>4.2.4.2数据库设计文档条理清晰无误；设计文档条例清晰无误得100%，其余情况不得</p>
        <p>4.2.4.3数据库命名要求符合行业标准；严格按照行业标准编写得100%，80%规范得50%，不规范不得</p>
        <p>4.2.4.4保证项目可遗传性；全部保证得100%，其余不得</p>
        <p>4.2.5后台开发考核标准</p>
        <p>4.2.5.1代码编写简洁、美观，结构清晰，且注释齐全；严格按照行业标准编写；美观规范得100%，规范不美观得70%，不规范不美观不得</p>
        <p>4.2.5.2接口文档清晰完整；清晰完整易读性高得100%，其余情况不得</p>
        <p>4.2.5.3接口一次性合格率80%得100%，其余情况不得</p>
        <p>4.2.5.4当日必须更新完成当日的接口文档；保质保量完成得100%，完成80%得50%，其余情况不得</p>
        <p>4.2.5.5保证项目可遗传性；全部保证得100%，其余不得</p>
        <p>4.2.6前后台交互设计考核标准</p>
        <p>4.2.6.1前台与后台如期实现预定功能；全部完成得100%，80%完成得50%，其余情况不得</p>
        <p>4.2.6.2实现的功能符合设计功能；全部符合得100%，80%符合得50%，其余情况不得</p>
        <p>4.2.7项目测试考核标准</p>
        <p>4.2.7.1测试项目业务流程、逻辑通顺得100%，80%完成得50%，其余情况不得</p>
        <p>4.2.7.2测试数据正常得100%，80%正常得50%，其余情况不得</p>
        <p>4.2.8项目档案制作考核标准</p>
        <p>4.2.8.1所需文档资料内容覆盖率95%得100%，覆盖率80%得50%，其余情况不得</p>
        <p>4.2.8.2所需文档资料齐全得100%，80%齐全得50%，其余情况不得</p>
        <p>4.2.9项目试运行考核标准</p>
        <p>4.2.9.1项目试运行阶段，保证项目运行无报错率达到85%以上得100%，达到70以上得50%，其余情况不得</p>
        <p>4.2.9.2项目试运行阶段，稳定性达到90%以上得100%,达到75以上得50%，其余情况不得</p>
        <p>4.2.10项目验收考核标准</p>
        <p>4.2.10.1项目验收资料准备齐全得100%，80%齐全得50%，其余情况不得</p>
        <p>4.2.10.2完成开发资料交接工作得100%，80%完成得50%，其余情况不得</p>
        <p>4.2.10.3 完成合同技术要求验收工作得100%，80%完成得50%，其余情况不得</p>
        <p>4.2.11运维考核标准</p>
        <p>4.2.11.1保障项目运行环境稳定率达到95%得100%，达到80%得50%，其余情况不得</p>
        <p>4.2.11.2保障项目数据库备份率达到100%得100%，达到80%得50%，其余情况不得</p>

        <h4 name="0-5-1-6-3" className="point" id="0-5-1-6-3">7.4 电商中心人员岗位职责</h4>
        <br/>
            <div><strong style={{color:'#6699FF'}}>附件：</strong><a href="javascript:void(0);" type="primary" id='Enclosure66' title="《电商中心人员岗位职责》" onClick={(value)=>this.showDrawer(value)}>《电商中心人员岗位职责》</a></div>
        <br/>
    </div>
        )
    }
}

export default Section$;